import React, { Component, forwardRef } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import {
  getExhibitorExitPassDetails_action,
  submitExhibitorExitPass_action, updateExhibitorExitPass_action,
  deleteExitPass_action,
  getAccountExitPassDetail_action,
} from "../../../actions/exhibitor_module_actions/exhibitor_exit_pass_action/exhibitor_exit_pass_action";
import {
  insertExitPassOTP_action,
  verifyExitPassOTP_action,
  approveRejectExitPass_action,
  getExitPassPdf_action,
  resubmitExitPass_action, checkIfApproved_action
} from "../../../actions/admin_module_action/account_exit_pass_action/account_exit_pass_action";
import { fill_action } from "../../../actions/fillCombo_action";
import { getVendorBasicDetail_action } from "../../../actions/vendor_module_action/vendor_order_action";
import { connect } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import {
  contractorListActionId,
  toastError,
  toastSuccess,
  exhibitorBadgeDaysActionId,
  link_BASE_URL,
  downloadReport, vehicleTypeActionId,
  fetchAuthReport,
} from "../../../utils/constants";
import $ from "jquery";
import moment from "moment";
import AdminHeader from "../../../common_components/admin_module_header";
import DatePicker from "react-datepicker";
import Modal from "react-modal";
import { emailValidator, mobileNoValidator } from "../../../utils/Validator";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import { sendPaymentForm_action } from "../../../actions/payment_action/payment_action";
import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { checkEntryPassExists_action } from "../../../actions/vendor_module_action/vendor_exhibition_list_action/vendor_exhibition_list_action";
// import { getAccountExitPassList_action, insertExitPassOTP_action, getExitPassPdf_action, verifyExitPassOTP_action } from "../../../actions/admin_module_action/account_exit_pass_action/account_exit_pass_action";
import ConfirmationModal from "../../../common_components/confirmationa_modal";
import Resizer from "react-image-file-resizer";
import {
  deleteEntryPassDriverDoc_action
} from "../../../actions/exhibitor_module_actions/exhibitorEntryPass_action/exhibitorEntryPass_action";
class ExhibitorExitPass extends Component {
  // Initialize Constructor
  constructor(props) {
    super(props);
    //States
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      categoryType:
        sessionStorage.getItem("RoleIDSS") == 1 ? "Exhibitor" : "contractor",
      itemToCarryList: [
        {
          ItemName: "",
          Quantity: "",
          isFromDb: false,
          Nameerr: false,
          Quantityerr: false,
        },
      ],
      contractorList: [],
      ContractorId: null,
      exhibitorDetailsData: {},
      personName: "",
      personNameErr: "",
      companyName: "",
      companyNameErr: "",
      email: "",
      emailErr: "",
      contactNo: "",
      contactNoErr: "",
      ExitDate: new Date(),
      categoryList: [],
      isOpen: false,
      ExitDateErr: "",
      QrCodeImg: "",
      RoleId: sessionStorage.getItem("RoleIDSS"),
      IsNDCIssued: false,
      extraServices: [],
      totalOutstanding: 0,
      totalPayable: 0,
      totalPaidAmount: 0,
      PIarr: [],
      paymentLink: "",

      exhUUID: "",
      contractorUUID: "",
      isCopyModal: false,
      isCopied: false,
      copiedIndex: "",
      isDirectContractor: false,

      isFullOut: false,
      isView: false,
      ExhID: "",
      exitPassId: "",

      RSPpersonName: "",
      RSPcompanyName: "",
      RSPcontactNo: "",
      RSPemailID: "",
      REpersonName: "",
      REcompanyName: "",
      REcontactNo: "",
      REemailID: "",
      RSPpersonNameErr: "",
      RSPcompanyNameErr: "",
      RSPcontactNoErr: "",
      RSPemailIDErr: "",
      REpersonNameErr: "",
      REcompanyNameErr: "",
      REcontactNoErr: "",
      REemailIDErr: "",

      isWaiverOn: false,
      otpValid: false,
      inputOTP: "",
      approvedByName: "",
      remark: "",
      inputOTPErr: "",
      approvedByNameErr: "",
      refuseModal: false,
      refuseReason: "",
      toShowPay: false,

      isApproved: false,
      rejectReason: "",
      rejectReasonModal: false,
      ExitPassStatus: "",
      vendorBasicData: null,
      isVendor: false,
      ExitNo: "",

      mailDataPersonName: "",
      mailDatacompanyName: "",
      mailDatacontactNo: "",
      mailDataemail: "",
      ITMEStaffName: sessionStorage.getItem("firstNameSS"),
      ITMEStaffNameErr: '',
      IssuedDate: new Date(),
      IssuedDateErr: '',

      isIntervalOn: false,
      approvalStatus: '',
      adminEmail: '',
      adminUserId: '',

      editOpen: false,
      editIndex: null,
      editExitHdrId: '',
      editExitHdrNo: '',
      vehicleTypeList: [],
      editListItemsTocarry: [],
      oldEditQuantity: '',
      deletePop: false,
      showVideoModal: false,

      setupDate: '',
      IsAgree: false,
      dismantleDate: '',
      showExitPass: false,
      isLastExitPass: false,
      listOfVehicles: [],
      tempListOfVehicles: [],
      noOfVehicles: '',
      noOfVehiclesErr: '',
      editNoOfVehicles: '',
      editNoOfVehiclesErr: '',
      tempMainListOfVehicles: [],
      mainListOfVehicles: [],
      delID: '',
    };
    this.deleteExitPass = this.deleteExitPass.bind(this);
    this.submitfrm = React.createRef();
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.navPayment = this.navPayment.bind(this);
    this.onWaiveClick = this.onWaiveClick.bind(this);
    this.onSendOTP = this.onSendOTP.bind(this);
    this.checkOTP = this.checkOTP.bind(this);
    this.onGenerateExitPass = this.onGenerateExitPass.bind(this);
    this.onPOut = this.onPOut.bind(this);
    this.onResubmit = this.onResubmit.bind(this);
    this.onPassDownload = this.onPassDownload.bind(this);
    this.onPassPrint = this.onPassPrint.bind(this);
    this.checkApproval = this.checkApproval.bind(this);
    this.setOldQty = this.setOldQty.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.setState({ editIndex: popArg[0], editListItemsTocarry: popArg[1], editExitHdrId: popArg[2], editExitHdrNo: popArg[3], editListOfVehicles: popArg[4], editNoOfVehicles: popArg[5] }, () => this.updateExhibitorExitPass(popArg[6], 0))
      }
      if (confirmationObj.action == 1) {
        this.onResubmit(popArg[0])
      }
      if (confirmationObj.action == 2) {
        this.onPassDownload(popArg[0])
      }
      if (confirmationObj.action == 3) {
        this.onPassPrint(popArg[0])
      }
      if (confirmationObj.action == 4) {
        this.updateExhibitorExitPass(popArg[0], 1)
      }
      if (confirmationObj.action == 5) {
        this.updateExhibitorExitPass(popArg[0], 1)
      }
      if (confirmationObj.action == 6) {
        this.onWaiveClick()
      }
      if (confirmationObj.action == 7) {
        this.submitExhibitorExitPass(popArg[0])
      }
      if (confirmationObj.action == 8) {
        this.submitExhibitorExitPass(popArg[0])
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    const { contractorList, RoleId } = this.state;

    // Call vendor details if vendor login
    if (RoleId == 7 || RoleId == 17) {
      this.getVendorBasicDetails();
    }

    this.props.checkEntryPassExists_action()
      .then((data) => {
        if (data.error != 1 && data.data?.entryPassCount?.[0]?.Cnt !== undefined) {
          this.setState({
            showEntryPassWarning: data.data.entryPassCount[0].Cnt === 0
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });

    var fullUrl = window.location.href;
    fullUrl = fullUrl.split("/");
    console.log(fullUrl);
    if (fullUrl.length == 8) {
      this.setState({ isDirectContractor: true });

      sessionStorage.setItem("sessionExhibitionID", fullUrl[6]);
      console.log(fullUrl[7], fullUrl[6]);
      this.getFillList(vehicleTypeActionId, "", "", "", "", "")
      this.getExhibitorExitPassDetails(fullUrl[7], fullUrl[6]).then(() => {
        this.getFillList(contractorListActionId, "", "", "", "", "").then(
          (arr) => {
            arr.length > 0 &&
              arr.forEach((item) => {
                console.log(item.UUID, fullUrl[5]);
                if (item.UUID == fullUrl[5]) {
                  this.setState({ ContractorId: item.ContractorID }, () => {
                    this.getExhibitorExitPassDetails(
                      fullUrl[7],
                      fullUrl[6]
                    ).then(() => { });
                  });
                }
              });
          }
        );
      });
    } else {
      this.getFillList(vehicleTypeActionId, "", "", "", "", "")
      if (fullUrl.length == 6) {
        if (fullUrl[fullUrl.length - 1] == "Success") {
          toastSuccess("Payment successful");
        } else if (fullUrl[fullUrl.length - 1] == "Invalid") {
          toastError("Payment for the order is already processed");
        } else if (fullUrl[fullUrl.length - 1] == "Failure") {
          toastError(
            "Due to some technical reason your payment failed please try again later or contact to India ITME Society."
          );
        }
      }
      console.log(this.props.location.state, "this.props.location.state");
      if (this.props.location.state != null) {
        setTimeout(() => {
          this.setState({ ITMEStaffName: sessionStorage.getItem("firstNameSS"), IssuedDate: new Date() })
        }, 200);
        if (
          this.props.location.state.isExhibitor != null &&
          this.props.location.state.isExhibitor != undefined
        ) {
          this.setState({
            categoryType: this.props.location.state.isExhibitor
              ? "Exhibitor"
              : "contractor",
          });
          this.setState({ isView: this.props.location.state.is_view }, () => {
            this.getFillList(contractorListActionId, "", "", "", "", this.props.location.state != null ? this.props.location.state.regId != '' && this.props.location.state.regId != null ? this.props.location.state.regId : '' : '');
            this.getExhibitorExitPassDetails(this.props.location.state.regId);
          });
          this.setState({ exitPassId: this.props.location.state.exitId });
          this.setState({ ContractorId: this.props.location.state.vendorID });
          this.setState({ ExitNo: this.props.location.state.ExitNo });
          this.setState({
            ExhID: this.props.location.state.regId,
          });

          this.setState({
            isVendor: this.props.location.state.isVendor || false,
          });
          console.log(
            this.props.location.state,
            "this.props.location.state.isVendor"
          );
          // if (this.props.location.state.isExhibitor) {
          //     this.setState({ ExhID: this.props.location.state.regId, ContractorId: '' })
          // } else {
          //     this.setState({ ContractorId: this.props.location.state.regId, ExhID: '' })
          // }
          if (this.props.location.state.otherInfo != null) {
            this.setState({
              mailDatacompanyName:
                this.props.location.state.otherInfo.companyName,
              mailDataPersonName:
                this.props.location.state.otherInfo.personName,
              mailDatacontactNo: this.props.location.state.otherInfo.contactNo,
              mailDataemail: this.props.location.state.otherInfo.email,
            });
          }
        }
        this.mycheckApprovalFunction(this.props.location.state.exitId)
      } else {
        this.getFillList(contractorListActionId, "", "", "", "", this.props.location.state != null ? this.props.location.state.regId != '' && this.props.location.state.regId != null ? this.props.location.state.regId : '' : '');
        setTimeout(() => {
          this.getExhibitorExitPassDetails();
        }, 200);
      }
    }
    this.loadscript();
  }
  componentWillUnmount() {
    // Cleanup to avoid memory leaks
    this.stopInterval();
  }

  mycheckApprovalFunction = (id) => {
    console.log("Function called", this.state.isIntervalOn);
    //  console.log(id);
    // this.setState({ isLoading: true });
    this.props
      .checkIfApproved_action(id != '' && id != null && id != undefined ? id : this.state.exitPassId)
      .then((data) => {
        if (data.error != 1) {
          console.log(data)
          if (data.data[0][0].WaiveOffStatus != "0") {
            console.log('here')
            this.setState({
              approvalStatus: 'Approved', approvedByName: data.data[0][0].WaiveOffStatus, isWaiverOn: true
            }, () => {
              this.stopInterval();
            })
          }
        } else {
          this.setState({ isLoading: false });
          // toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  };

  startInterval = () => {
    // Prevent multiple intervals
    if (!this.state.isIntervalOn) {
      this.state.isIntervalOn = setInterval(this.mycheckApprovalFunction, 3000);
    }
  };

  stopInterval = () => {
    clearInterval(this.state.isIntervalOn);
    this.state.isIntervalOn = false;
    this.setState({ isIntervalOn: false })
  };

  getFillList(
    actionID,
    exhibitionID,
    moduleID,
    keyValue,
    value,
    exhRegistrationID
  ) {
    return new Promise((resolve, reject) => {
      const { } = this.state;
      this.setState({ isLoading: true });
      this.props
        .fill_action(
          actionID,
          exhibitionID,
          moduleID,
          keyValue,
          value,
          exhRegistrationID
        )
        .then((data) => {
          if (data.error != 1) {
            // Instrument Type list
            if (actionID === contractorListActionId) {
              const array = [];
              data.data.map((item, i) => {
                array.push(item);
              });
              // array.push({ ContractorID: 0, CompanyName: "Other" });
              this.setState(
                {
                  contractorList: array,
                  //  isLoading: false,
                },
                () => {
                  resolve(array);
                }
              );
            }
            if (actionID === vehicleTypeActionId) {
              const array = [];
              data.data.map((item, i) => {
                array.push(item);
              });
              // array.push({ ContractorID: 0, CompanyName: "Other" });
              this.setState(
                {
                  vehicleTypeList: array,
                  //  isLoading: false,
                },
                () => {
                  resolve(array);
                }
              );
            }
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    });
  }

  inputValidate() {
    const {
      personName,
      companyName,
      contactNo,
      email,
      ExitDate,
      categoryType,
      itemToCarryList,
      ContractorId,
    } = this.state;

    if (ExitDate == "" || ExitDate == null) {
      this.setState({ ExitDateErr: "Please select Exit Date" });
    }
    if (categoryType == "contractor" && ContractorId === 0) {
      if (personName == "" || personName == null) {
        this.setState({ personNameErr: "Please Enter Person Name" });
      }
      if (companyName == "" || companyName == null) {
        this.setState({ companyNameErr: "Please Enter Company Name" });
      }
      if (contactNo == "" || contactNo == null) {
        this.setState({ contactNoErr: "Please Enter Contact No." });
      }
      if (contactNo != "") {
        var contactNoError = mobileNoValidator(contactNo);
        if (contactNoError != "") {
          this.setState({ contactNoErr: contactNoError });
        }
      }
      if (email == "" || email == null) {
        this.setState({ emailErr: "Please enter Email" });
      }
      if (email != "") {
        var emailError = emailValidator(email);
        if (emailError != "") {
          this.setState({ emailErr: emailError });
        }
      }
    }
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleOpenForm(ID, deadline, StatusID, name, ServiceID) {
    this.props.navigate("/manualFormsVendorList", {
      state: {
        Deadline: deadline,
        StatusID,
        ManualFormsID: ID,
        ManualFormsName: name,
        ServiceID: ServiceID,
      },
    });
  }


  deleteExitPass() {
    const { ContractorId, isView, editExitHdrId, } = this.state;
    // return new Promise((resolve, reject) => {
    this.setState({ isLoading: true });
    console.log("ContractorId--------->", ContractorId);
    // if (isView) {
    this.props
      .deleteExitPass_action(editExitHdrId)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Material Exit pass deleted successfully!");

          this.setState({ isLoading: true });
          this.getExhibitorExitPassDetails()
          this.setState({
            // companyName: '',
            // personName: '',
            // contactNo: '',
            // email: '',
            // categoryType:
            //   sessionStorage.getItem("RoleIDSS") == 1
            //     ? "Exhibitor"
            //     : sessionStorage.getItem("RoleIDSS") == 7
            //       ? "contractor"
            //       : "contractor",
            editListItemsTocarry: [], editIndex: null, editOpen: false, editExitHdrId: '', deletePop: false
          })
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
          // reject(data.msg);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
        // reject(err);
      });
    // }
    // })
  }

  onPassDownload(id) {
    console.log(id);
    this.setState({ isLoading: true });
    this.props
      .getExitPassPdf_action(id)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          console.log("Proforma Pdf Download", data);
          var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
          const win = window.location.replace(url, "_blank");
          if (win != null) {
            win.focus();
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async onPassPrint(id) {
    console.log(id);
    this.setState({ isLoading: true });
    try {
      var list = [];
      const mapdata1 = {
        ParameterName: "@ExhExitpassHdrID",
        ParameterValue: id,
        ParameterDataType: "int",
      };
      list.push(mapdata1);
      const mapData = {
        report_name: "ExitPass.rpt",
        parameter_details: list,
      };
      console.log("xxxxxxxxxxxxxxxxxxxxx", mapData);
      const res = await axiosPost(fetchAuthReport, mapData);
      this.setState({ isLoading: false });

      if (res != null) {
        var url = `${downloadReport}?SessionIdentifier=${res}`;
        const win = window.open(url, "_blank", "noopener,noreferrer");
        if (win != null) {
          win.focus();
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  navPayment(e) {
    e.preventDefault();
    const {
      isLoading,
      isFullOut,
      categoryType,
      isCopied,
      isCopyModal,
      copiedIndex,
      isDirectContractor,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      extraServices,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      ExitDate,
      totalOutstanding,
      totalPaidAmount,
      totalPayable,
      categoryList,
      isOpen,
      ExitDateErr,
      PIarr,
      RoleId,
    } = this.state;

    console.log(PIarr, totalOutstanding);
    this.setState({ isLoading: true });
    this.props
      .sendPaymentForm_action(
        sessionStorage.getItem("sessionExhibitionID"),
        sessionStorage.getItem("ExhRegistrationIDSS"),
        totalOutstanding.toFixed(2),
        sessionStorage.getItem("ApplicationDataSS") != null
          ? JSON.parse(sessionStorage.getItem("ApplicationDataSS"))
            .CurrencyID == 1
            ? "INR"
            : "USD"
          : "INR",
        PIarr,
        "exitPass",
        null,
        "", '', sessionStorage.getItem("ExhRegistrationNo")
      )
      .then((data) => {
        console.log(data);
        if (data.error != 1) {
          if (data != null) {
            console.log("payment response : ", data);

            this.setState({ paymentLink: data.data }, () => {
              // this.submitfrm.current.submit()
              // window.open(data.data, '_blank')
              window.location.replace(data.data);
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError("There is some problem. Please try again later!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getExhibitorExitPassDetails(UUID, exhibitionID) {
    const {
      ContractorId,
      isView,
      exitPassId,
      extraServices,
      isApproved,
      ExitPassStatus,
    } = this.state;
    return new Promise((resolve, reject) => {
      this.setState({ isLoading: true });
      // console.log('  listOfVehicles: data.data[6]', data.data[6])
      console.log("ContractorId--------->", ContractorId);
      if (isView) {
        this.props
          .getAccountExitPassDetail_action(exitPassId, UUID)
          .then((data) => {
            console.log('  listOfVehicles: data.data[6]', data.data[6])
            if (data.error != 1) {
              if (data.data.length > 0) {
                const array = [];
                var tempApproveFlag = false;
                var tempExitPassStatus = "";
                data.data[7].length > 0 && data.data[7].map(item => {
                  var filePath = item.DriverDocument
                  var docarray = item.DriverDocument != null && item.DriverDocument != "" && filePath.split("/")
                  var FileName = docarray[docarray.length - 1]
                  item.driverDocName = FileName
                  // item.driverDocName = FileName
                  item.driverDocPath = filePath
                  item.driverDocdeleted = false
                  item.IsOutSelect = item.IsOut
                })
                data.data[1].forEach((item) => {
                  item.itemToCarryList = data.data[2].filter(
                    (obj) => obj.ExhExitPassHdrID === item.ExhExitPassHdrID
                  );
                  item.vehicleList = data.data[7].filter(
                    (obj) => obj.ExhExitPassHdrID[0] === item.ExhExitPassHdrID
                  );
                  array.push(item);
                  tempExitPassStatus = item.ExitPassStatus;

                });
                if (data.data[0][0].isApproved) {
                  tempApproveFlag = true;
                }
                var totalOutstanding = 0;
                var totalPayable = 0;
                var totalPaidAmount = 0;
                var Piarr = [];
                var toShowPay = false;
                data.data[3].map((item) => {
                  totalOutstanding =
                    totalOutstanding + parseFloat(item.Outstanding);
                  totalPaidAmount =
                    totalPaidAmount + parseFloat(item.PaidAmount);
                  totalPayable = totalPayable + parseFloat(item.TotalPayable);
                  Piarr.push({ ProformaInvoiceID: item.ProformaInvoiceID });
                  if (item.Is_payAllowed == 1) {
                    toShowPay = true;
                  }
                });
                const updateData = {
                  isLoading: false,
                  categoryList: array,
                  itemToCarryList: [
                    {
                      ItemName: "",
                      Quantity: "",
                      isFromDb: false,
                      Nameerr: false,
                      Quantityerr: false,
                    },
                  ],
                  extraServices: data.data[3],
                  toShowPay: toShowPay,
                  isApproved: tempApproveFlag,
                  totalOutstanding: totalOutstanding,
                  IsNDCIssued: data.data?.[0]?.[0]?.IsNDCIssued || false,
                  totalPayable: totalPayable,
                  totalPaidAmount: totalPaidAmount,
                  PIarr: Piarr,
                };
                if (sessionStorage.getItem("RoleIDSS") != 7 && sessionStorage.getItem("RoleIDSS") != 17) {
                  updateData.exhibitorDetailsData = data.data[0][0];
                }
                if (data.data[1].length > 0) {
                  // var isLastEP = false
                  this.setState({
                    personName: data.data[1][0].PersonName,
                    companyName: data.data[1][0].CompanyName,
                    contactNo: data.data[1][0].MobileNo,
                    email: data.data[1][0].EmailID,
                    ITMEStaffName: data.data[1][0].ITMEStaffName,
                    IssuedDate: data.data[1][0].IssuedDate,
                    // listOfVehicles: JSON.parse(JSON.stringify(data.data[7])),
                    // tempListOfVehicles: JSON.parse(JSON.stringify(data.data[7]))
                  });
                  // data.data[1].map(item => {
                  //   if (item.isLastExitPass) {
                  //     isLastEP = true
                  //   }
                  // })
                  // this.setState({
                  //   isLastExitPass: isLastEP
                  // })
                }
                this.setState(updateData);
                if (data.data[4] != undefined && data.data[4].length > 0) {
                  this.setState({
                    RSPpersonName: data.data[4][0].PersonName || "",
                    RSPcompanyName: data.data[4][0].CompanyName || "",
                    RSPcontactNo: data.data[4][0].ContactNo || "",
                    RSPemailID: data.data[4][0].Email || "",
                    REpersonName: data.data[4][0].ExitPersonName || "",
                    REcompanyName: data.data[4][0].ExitCompanyName || "",
                    REcontactNo: data.data[4][0].ExitMobileNo || "",
                    REemailID: data.data[4][0].ExitEmailID || "",
                  });
                }
                if (data.data[5].length > 0) {
                  var emailArr = []
                  var userIdArr = []
                  data.data[5].map(item => {
                    emailArr.push(item.PrimaryEmail)
                    userIdArr.push(item.UserId)
                  })
                  this.setState({
                    adminEmail: emailArr || "",
                    adminUserId: userIdArr || "",
                    ExitPassStatus: tempExitPassStatus,
                  })
                }
                // console.log(data.data[3][0].SetupStartDate, '////', new Date(), moment(data.data[3][0].SetupStartDate).format('YYYY-MM-DD'))
                if (data.data[5].length > 0) {

                  this.setState({
                    setupDate: moment(data.data[5][0].SetupStartDate).format('YYYY-MM-DD'),
                    dismantleDate: moment(data.data[5][0].DismantleEndDate).format('YYYY-MM-DD'),
                    ExitDate: moment(data.data[5][0].SetupStartDate).format('YYYY-MM-DD')
                  });
                }
                // this.setState({ listOfVehicles: data.data[7], tempListOfVehicles: JSON.parse(JSON.stringify(data.data[7])) })
                resolve(true);
              }
              this.setState({ isLoading: false });
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.props
          .getExhibitorExitPassDetails_action(
            ContractorId,
            UUID != null && UUID != "" && UUID != undefined ? UUID : null,
            exhibitionID != null &&
              exhibitionID != "" &&
              exhibitionID != undefined
              ? exhibitionID
              : null
          )
          .then((data) => {
            if (data.error != 1) {
              if (data.data.length > 0) {
                this.setState({
                  showExitPass: sessionStorage.getItem("RoleIDSS") == 1 ? !data.data[0][0]['IsEntryFill'] : false
                })

                const array = [];
                var tempApproveFlag = false;
                data.data[2].map(item1 => {
                  data.data[3].map(item2 => {
                    if (item1.ItemName == item2.ItemName) {
                      item1.isFromDb = true
                    }
                  })
                })
                data.data[6].length > 0 && data.data[6].map(item => {
                  var filePath = item.DriverDocument
                  var docarray = item.DriverDocument != null && item.DriverDocument != "" && filePath.split("/")
                  var FileName = docarray[docarray.length - 1]
                  item.driverDocName = FileName
                  item.driverDocPath = filePath
                  item.driverDocdeleted = false
                  item.IsOutSelect = item.IsOut
                })
                data.data[1].forEach((item) => {
                  item.itemToCarryList = data.data[2].filter(
                    (obj) => obj.ExhExitPassHdrID === item.ExhExitPassHdrID
                  );
                  item.vehicleList = data.data[6].filter(
                    (obj) => obj.ExhExitPassHdrID[0] === item.ExhExitPassHdrID
                  );
                  array.push(item);
                });

                // data.data[1].forEach((item) => {
                //   item.itemToCarryList = data.data[2].filter(
                //     (obj) => obj.ExhExitPassHdrID === item.ExhExitPassHdrID
                //   );
                //   array.push(item);
                //   // if (item.ExitPassStatus == "Approved") {
                //   //   tempApproveFlag = true;
                //   // }
                // });
                var isLastEP = false
                data.data[1].map(item => {
                  if (item.isLastExitPass) {
                    isLastEP = true
                  }
                })
                this.setState({
                  isLastExitPass: isLastEP
                })
                if (data.data[0].length > 0 && data.data[0][0].isApproved) {
                  tempApproveFlag = true;
                }
                var totalOutstanding = 0;
                var totalPayable = 0;
                var totalPaidAmount = 0;
                var Piarr = [];
                var toShowPay = false;
                data.data[4].forEach((item) => {
                  totalOutstanding =
                    totalOutstanding + parseFloat(item.Outstanding);
                  totalPaidAmount =
                    totalPaidAmount + parseFloat(item.PaidAmount);
                  totalPayable = totalPayable + parseFloat(item.TotalPayable);
                  Piarr.push({ ProformaInvoiceID: item.ProformaInvoiceID });
                  if (item.Is_payAllowed == 1) {
                    toShowPay = true;
                  }
                });
                data.data[3].length > 0 &&
                  data.data[3].forEach((item) => {
                    item.Quantity = "";
                    item.isDelete = false;
                    item.isFromDb = true;
                  });
                var isAll0 = data.data[3].every(
                  (obj) =>
                    obj.BalanceQuantity === 0 ||
                    obj.BalanceQuantity === "" ||
                    obj.BalanceQuantity === null
                );
                var newItemToCarryList = isAll0
                  ? []
                  : data.data[3].filter(
                    (item) =>
                      item.BalanceQuantity != 0 &&
                      item.BalanceQuantity != null &&
                      item.BalanceQuantity != ""
                  );
                // Don't overwrite exhibitorDetailsData for vendor (RoleId == 7)
                const updateData =
                  (sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 17)
                    ? {
                      isLoading: false,
                      categoryList: array,
                      itemToCarryList:
                        newItemToCarryList.length == 0 || isAll0
                          ? [
                            {
                              ItemName: "",
                              Quantity: "",
                              isFromDb: false,
                              Nameerr: false,
                              Quantityerr: false,
                            },
                          ]
                          : newItemToCarryList,
                      extraServices: data.data[4],
                      totalOutstanding: totalOutstanding,
                      IsNDCIssued: data.data?.[0]?.[0]?.IsNDCIssued || false,
                      totalPayable: totalPayable,
                      totalPaidAmount: totalPaidAmount,
                      exhUUID: data.data?.[0]?.[0]?.UUID || "",
                      PIarr: Piarr,
                      toShowPay: toShowPay,
                      isApproved: tempApproveFlag,
                    }
                    : {
                      isLoading: false,
                      exhibitorDetailsData: data.data[0][0],
                      categoryList: array,
                      itemToCarryList:
                        newItemToCarryList.length == 0 || isAll0
                          ? [
                            {
                              ItemName: "",
                              Quantity: "",
                              isFromDb: false,
                              Nameerr: false,
                              Quantityerr: false,
                            },
                          ]
                          : newItemToCarryList,
                      extraServices: data.data[4],
                      totalOutstanding: totalOutstanding,
                      totalPayable: totalPayable,
                      totalPaidAmount: totalPaidAmount,
                      exhUUID: data.data[0][0]?.UUID || "",
                      PIarr: Piarr,
                      toShowPay: toShowPay,
                      isApproved: tempApproveFlag,
                    };
                this.setState(updateData);
                sessionStorage.setItem(
                  "ExhRegistrationIDSS",
                  data.data[0][0] ? data.data[0][0].ExhRegistrationID : null
                );
                // console.log(data.data[3][0].SetupStartDate, '////', new Date(), moment(data.data[3][0].SetupStartDate).format('YYYY-MM-DD'))
                if (data.data[5].length > 0) {
                  this.setState({
                    setupDate: moment(data.data[5][0].SetupStartDate).format('YYYY-MM-DD'),
                    dismantleDate: moment(data.data[5][0].DismantleEndDate).format('YYYY-MM-DD'),
                    ExitDate: moment(data.data[5][0].SetupStartDate).format('YYYY-MM-DD')
                  });
                }
                setTimeout(() => {

                  console.log('SON.stringify(data.data[6])', array)

                  // this.setState({ listOfVehicles: data.data[6], tempListOfVehicles: JSON.parse(JSON.stringify(data.data[6])) })
                }, 500);
                resolve(true);
              }
              this.setState({ isLoading: false });
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

  handleClearErr() {
    this.setState({
      companyNameErr: "",
      personNameErr: "",
      contactNoErr: "",
      emailErr: "",
      companyName: "",
      personName: "",
      contactNo: "",
      email: "",
    });
  }

  onResubmit(id) {
    const {
      isLoading,
      isFullOut,
      categoryType,
      otpValid,
      isCopied,
      isCopyModal,
      copiedIndex,
      isDirectContractor,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      extraServices,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      ExitDate,
      totalOutstanding,
      totalPaidAmount,
      totalPayable,
      categoryList,
      isOpen,
      ExitDateErr,
      RoleId,
      refuseReason,
      REcompanyName,
      REcontactNo,
      REemailID,
      REpersonName,
      RSPcompanyName,
      RSPcontactNo,
      RSPemailID,
      RSPpersonName,
      REcompanyNameErr,
      REcontactNoErr,
      REemailIDErr,
      REpersonNameErr,
      RSPcompanyNameErr,
      ExhID,
      exitPassId,
      RSPcontactNoErr,
      RSPemailIDErr,
      RSPpersonNameErr,
      isWaiverOn,
      inputOTP,
      approvedByName,
      remark,
    } = this.state;
    this.props
      .resubmitExitPass_action(id)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess("Resubmit successful");
          // this.props.navigate('/accountExitPassList')
          this.getExhibitorExitPassDetails();
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  onGenerateExitPass(flag) {
    const {
      isLoading,
      isFullOut,
      categoryType,
      otpValid,
      isCopied,
      isCopyModal,
      copiedIndex,
      isDirectContractor,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      extraServices,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      ExitDate,
      totalOutstanding,
      totalPaidAmount,
      totalPayable,
      categoryList,
      isOpen,
      ExitDateErr,
      RoleId,
      refuseReason,
      REcompanyName,
      REcontactNo,
      REemailID,
      REpersonName,
      RSPcompanyName,
      RSPcontactNo,
      RSPemailID,
      RSPpersonName,
      REcompanyNameErr,
      REcontactNoErr,
      REemailIDErr,
      REpersonNameErr,
      RSPcompanyNameErr,
      ExhID,
      exitPassId,
      RSPcontactNoErr,
      RSPemailIDErr,
      RSPpersonNameErr,
      isWaiverOn,
      inputOTP,
      approvedByName,
      remark,
      ITMEStaffName, IssuedDate
    } = this.state;
    var isErr = false;
    const { vendorBasicData, isVendor, ExitNo } = this.state;
    if (flag == 1) {
      const finalREcompanyName =
        isVendor == 1 && exhibitorDetailsData
          ? exhibitorDetailsData.ExhCompanyName
          : REcompanyName;
      const finalREpersonName =
        isVendor == 1 && exhibitorDetailsData
          ? exhibitorDetailsData.PersonName
          : REpersonName;
      const finalREcontactNo =
        isVendor == 1 && exhibitorDetailsData
          ? exhibitorDetailsData.MobileNo
          : REcontactNo;
      const finalREemailID =
        isVendor == 1 && exhibitorDetailsData
          ? exhibitorDetailsData.PrimaryEmail
          : REemailID;

      if (
        finalREcompanyName == "" ||
        finalREcompanyName == null ||
        finalREcompanyName == undefined
      ) {
        this.setState({ REcompanyNameErr: "Please enter Company Name" });
        console.log("1")

        isErr = true;
      }
      if (finalREcontactNo == "" || finalREcontactNo == null) {
        this.setState({ REcontactNoErr: "Please enter Contact No" });
        console.log("2")

        isErr = true;
      }
      if (finalREemailID == "" || finalREemailID == null) {
        this.setState({ REemailIDErr: "Please enter EmailID" });
        console.log("3")
        isErr = true;
      }
      if (finalREpersonName == "" || finalREpersonName == null) {
        this.setState({ REpersonNameErr: "Please enter Person Name" });
        console.log("4")
        isErr = true;
      }
      if (RoleId != 7 && RoleId != 17 && isVendor != 1) {
        if (RSPcontactNo == "" || RSPcontactNo == null) {
          this.setState({ RSPcontactNoErr: "Please enter  Contact No" });
          console.log("5")
          isErr = true;
        }
        if (RSPemailID == "" || RSPemailID == null) {
          this.setState({ RSPemailIDErr: "Please enter EmailID" });
          console.log("6")
          isErr = true;
        }
        if (RSPpersonName == "" || RSPpersonName == null) {
          this.setState({ RSPpersonNameErr: "Please enter Person Name" });
          console.log("7")
          isErr = true;
        }
        if (RSPcompanyName == "" || RSPcompanyName == null) {
          this.setState({ RSPcompanyNameErr: "Please enter Company Name" });
          console.log("8")

          isErr = true;
        }
        if (ITMEStaffName == "" || ITMEStaffName == null) {
          this.setState({ ITMEStaffNameErr: "Please enter itme staff name" });
          console.log("9")
          isErr = true;
        }
        if (IssuedDate == "" || IssuedDate == null) {
          this.setState({ IssuedDateErr: "Please enter Date" });
          console.log("10")
          isErr = true;
        }
      }
      if (isWaiverOn) {
        // if (inputOTP == "" || inputOTP == null) {
        //   this.setState({ inputOTPErr: "Please enter OTP" });
        //   isErr = true;
        // }c
        if (approvedByName == "" || approvedByName == null) {
          this.setState({ approvedByNameErr: "Please enter Approved By Name" });
          console.log("11")
          isErr = true;
        }
        // if (!isErr) {
        //   if (!otpValid) {
        //     toastError("Invalid OTP");
        //     isErr = true;
        //   }
        // }
      }
      if (isErr) {
        toastError("Please enter mandatory Fields");
        return;
      } else {
        const emailData =
          (RoleId == 7 || RoleId == 17 || isVendor == 1) && vendorBasicData
            ? {
              person: `${vendorBasicData.PersonIncharge || ""} ${vendorBasicData.LastNamePersonIncharge || ""
                }`.trim(),
              PrimaryEmail: vendorBasicData.PrimaryEmail,
              ExhibitionName: sessionStorage.getItem("ExhibitionName"),
            }
            : {
              person: exhibitorDetailsData?.["Contact Person"]
                ? exhibitorDetailsData?.["Contact Person"]
                : exhibitorDetailsData?.["PersonName"],
              PrimaryEmail: exhibitorDetailsData?.["PrimaryEmail"],
              ExhibitionName: sessionStorage.getItem("ExhibitionName"),
            };
        const finalREcompanyName =
          isVendor == 1 && exhibitorDetailsData
            ? exhibitorDetailsData.ExhCompanyName
            : REcompanyName;
        const finalREpersonName =
          isVendor == 1 && exhibitorDetailsData
            ? exhibitorDetailsData.PersonName
            : REpersonName;
        const finalREcontactNo =
          isVendor == 1 && exhibitorDetailsData
            ? exhibitorDetailsData.MobileNo
            : REcontactNo;
        const finalREemailID =
          isVendor == 1 && exhibitorDetailsData
            ? exhibitorDetailsData.PrimaryEmail
            : REemailID;

        this.props
          .approveRejectExitPass_action(
            exitPassId,
            ExhID,
            1,
            "",
            isWaiverOn,
            finalREpersonName,
            finalREcompanyName,
            finalREcontactNo,
            finalREemailID,
            ExitNo,
            approvedByName,
            remark,
            emailData,
            ITMEStaffName ? ITMEStaffName : sessionStorage.getItem("firstNameSS"), IssuedDate ? IssuedDate : new Date()
          )
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isLoading: false });
              toastSuccess("Material Exit pass generated successfully");
              setTimeout(() => {
                this.props.navigate("/accountExitPassList");
              }, 1000);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    } else {
      if (refuseReason != "" && refuseReason != null) {
        const finalREcompanyName =
          isVendor == 1 && exhibitorDetailsData
            ? exhibitorDetailsData.ExhCompanyName
            : REcompanyName;
        const finalREpersonName =
          isVendor == 1 && exhibitorDetailsData
            ? exhibitorDetailsData.PersonName
            : REpersonName;
        const finalREcontactNo =
          isVendor == 1 && exhibitorDetailsData
            ? exhibitorDetailsData.MobileNo
            : REcontactNo;
        const finalREemailID =
          isVendor == 1 && exhibitorDetailsData
            ? exhibitorDetailsData.PrimaryEmail
            : REemailID;

        this.props
          .approveRejectExitPass_action(exitPassId, ExhID, 0, refuseReason, 0, finalREpersonName,
            finalREcompanyName,
            finalREcontactNo,
            finalREemailID, '', '', '', '', ITMEStaffName, IssuedDate)
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isLoading: false });
              this.setState({
                refuseModal: false,
              });
              toastSuccess("Updated successfully");
              setTimeout(() => {
                this.props.navigate("/accountExitPassList");
              }, 1000);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        toastError("Please enter refuse reason");
      }
    }
  }

  deleteExitPassDoc() {
    const { ContractorId, isView, categoryList, mainListOfVehicles, entryPassId, delID, editEntryHdrId, listOfVehicles, editListOfVehicles } = this.state;
    // const { isSSIandTMMAITAMMMA, delChapterID, exhibitDetailsList, } = this.state
    // e != undefined && e.preventDefault()
    // const { isDel2Open, logoImg, exhRegistrationID, isDel1Open, exhibitionID, SSIDocumentPath, isSSifile, isSSIdeleted, TMMAITAMMAfile, isTMMAITAMMAdeleted } = this.state
    this.setState({ isLoading: true })
    this.props.deleteEntryPassDriverDoc_action(null, delID)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(" Document Deleted SuccessFully")
          var ExhExitPassHdrIDtemp = ''
          editListOfVehicles.map(item => {
            if (item.ExitVehicleDtlID == delID) {
              item.driverDocFile = ''
              item.driverDocName = ''
              item.driverDocPath = ''
              item.driverDocType = ''
              item.DriverDocument = ''
              item.driverDocdeleted = true
              ExhExitPassHdrIDtemp = item.ExhExitPassHdrID[0]
            }
          })
          mainListOfVehicles.map(item => {
            if (item.ExitVehicleDtlID == delID) {
              item.driverDocFile = ''
              item.driverDocName = ''
              item.driverDocPath = ''
              item.driverDocType = ''
              item.DriverDocument = ''
              item.driverDocdeleted = true
              ExhExitPassHdrIDtemp = item.ExhExitPassHdrID[0]
            }
          })

          categoryList.map(item => {
            if (item.ExhExitPassHdrID == ExhExitPassHdrIDtemp) {
              item.vehicleList.length > 0 && item.vehicleList.map(item2 => {
                if (item2.ExitVehicleDtlID == delID) {
                  item2.driverDocFile = ''
                  item2.driverDocName = ''
                  item2.driverDocPath = ''
                  item2.driverDocType = ''
                  item2.DriverDocument = ''
                  item2.driverDocdeleted = true
                }

              })
            }
          })
          this.getExhibitorExitPassDetails()
          this.setState({ isLoading: false, isDelOpen: false, editListOfVehicles: editListOfVehicles, categoryList: categoryList })
        } else {
          toastError(data.msg)
          this.setState({ isLoading: false })
        }
      }).catch((error) => {
        console.log(error)
      })
  }

  updateExhibitorExitPass(mode, listFlag) {
    const { editExitHdrId, editExitHdrNo, editIndex, editListItemsTocarry, editOpen, exhUUID, exitPassId, deletePop,
      ExitDate, tempListOfVehicles,
      ContractorId,
      isView,
      categoryType, editNoOfVehicles, editListOfVehicles,
      exhibitorDetailsData,
      companyName,
      isFullOut,
      contractorList,
      personName,
      email,
      contactNo, listOfVehicles,
      itemToCarryList,
      emailErr,
      contactNoErr,
      RoleId,
      vendorBasicData,
    } = this.state;

    var startErr = false

    if (ExitDate == "" || ExitDate == null) {
      startErr = true
      this.setState({ ExitDateErr: "Please select Exit Date" });
    }
    if (categoryType == "contractor" && ContractorId === 0) {
      if (personName == "" || personName == null) {
        startErr = true
        this.setState({ personNameErr: "Please Enter Person Name" });
      }
      if (companyName == "" || companyName == null) {
        startErr = true
        this.setState({ companyNameErr: "Please Enter Company Name" });
      }
      if (contactNo == "" || contactNo == null) {
        startErr = true
        this.setState({ contactNoErr: "Please Enter Contact No." });
      }
      if (contactNo != "") {
        var contactNoError = mobileNoValidator(contactNo);
        if (contactNoError != "") {
          startErr = true
          this.setState({ contactNoErr: contactNoError });
        }
      }
      if (email == "" || email == null) {
        startErr = true
        this.setState({ emailErr: "Please enter Email" });
      }
      if (email != "") {
        var emailError = emailValidator(email);
        if (emailError != "") {
          startErr = true
          this.setState({ emailErr: emailError });
        }
      }
    }
    // this.inputValidate();
    if (startErr) {
      toastError("Please enter mandaotry fields")
      return
    }
    for (var i = 0; i < editListItemsTocarry.length; i++) {
      if (editListItemsTocarry[i].isFromDb) {
        if ((editListItemsTocarry[i].oldEditQuantity + editListItemsTocarry[i].BalanceQuantity) < editListItemsTocarry[i].Quantity) {
          toastError(
            `Current out qty should be less than or equal to ${editListItemsTocarry[i].oldEditQuantity + editListItemsTocarry[i].BalanceQuantity}`
          );
          return;
        }
      }
    }
    const nonEmptyItems = editListItemsTocarry.filter(
      (item) =>
        item.Quantity != "" && item.Quantity != null && item.Quantity != 0
    );
    const allnull = editListItemsTocarry.every(
      (item) =>
        (item.Quantity == "" ||
          item.Quantity == null ||
          item.Quantity == 0) &&
        (item.ItemName == "" || item.ItemName == null || item.ItemName == 0)
    );
    if (allnull) {
      return toastError("Please fill atleast one exit item");
    }
    const allQtynull = editListItemsTocarry.every(
      (item) =>
        item.Quantity == "" || item.Quantity == null || item.Quantity == 0
    );
    if (allQtynull) {
      return toastError("Please fill atleast one quantity");
    }
    if (nonEmptyItems.length > 0) {
      editListItemsTocarry.forEach((item) => {
        item.ItemName.trim()
        if (
          item.Quantity != "" &&
          item.Quantity != null &&
          item.Quantity != 0 &&
          item.ItemName.trim() == ""
        ) {
          item.Nameerr = true;
        }
      });
      this.setState({ editListItemsTocarry: editListItemsTocarry });
      const condition = nonEmptyItems.some(
        (item) => item.ItemName?.trim() == ""
      );
      if (condition) {
        return toastError("Please fill all item names");
      }
    }
    console.log(nonEmptyItems, "////");
    var isDuplicate = false;
    for (var i = 0; i < editListItemsTocarry.length; i++) {
      for (var j = 0; j < editListItemsTocarry.length; j++) {
        if (i != j) {
          if (editListItemsTocarry[i].ItemName == editListItemsTocarry[j].ItemName) {
            isDuplicate = true;
            break;
          }
        }
      }
    }
    if (isDuplicate) {
      toastError("Duplicate items names is not allowed");
      return;
    }
    const hasItemsFromDb = editListItemsTocarry.some((item) => item.isFromDb);
    var isNoselect = editListItemsTocarry.every(
      (item) =>
        item.Quantity == "" || item.Quantity == null || item.Quantity == 0
    );
    if (isNoselect && hasItemsFromDb) {
      toastError("Please input atleast 1 current out qty");
      return;
    }
    var newArr = editListItemsTocarry.filter(
      (item) =>
        item.Quantity != 0 && item.Quantity != null && item.Quantity != ""
    );
    var tempcompanyName = "";
    var temppersonName = "";
    var tempcontactNo = "";
    var tempemail = "";
    if (ContractorId != null && ContractorId != 0) {
      contractorList.map((item) => {
        if (item.ContractorID == ContractorId) {
          tempcompanyName = item.CompanyName;
          temppersonName = item.PersonName;
          tempcontactNo = item.MobileNo;
          tempemail = item.EmailId;
        }
      });
    }
    editListOfVehicles.length > 0 && editListOfVehicles.map((item => {
      item.type = item.VehicleTypeID
      item.driverName = item.DriverName
      item.driverNo = item.DriverMobNo
      item.VehicleNo = item.VehicleNo
      item.driverDocType = item.driverDocType ?? ''
      item.driverDocFile = item.driverDocFile ?? ''
    }))
    if (editNoOfVehicles == '' || editNoOfVehicles == null || editNoOfVehicles < 1) {
      this.setState({
        editNoOfVehiclesErr: 'Please enter atleast 1 vehicle'
      })
      return toastError("Please enter atleast 1 vehicle");
    }
    console.log(editNoOfVehicles)
    if (editNoOfVehicles != '' && editNoOfVehicles != null) {
      const condition3 = editListOfVehicles.some((item) => item.driverName?.trim() == "");
      if (condition3) {
        return toastError("Please fill all driver names");
      }
      const condition4 = editListOfVehicles.some((item) => item.type == '' || item.type == null);
      if (condition4) {
        return toastError("Please select all vehicle types");
      }
      const condition7 = editListOfVehicles.some((item) => item.VehicleNo == '' || item.VehicleNo == null);
      if (condition7) {
        return toastError("Please fill all Vehicle No");
      }
      const condition5 = editListOfVehicles.some((item) => item.driverNo == '' || item.driverNo == null);
      if (condition5) {
        return toastError("Please fill all driver mobile No");
      }
      const condition6 = editListOfVehicles.some((item) => (item.driverDocPath == '' || item.driverDocPath == null) && (item.driverDocType == '' || item.driverDocType == null));
      if (condition6) {
        return toastError("Please enter all driver documents");
      }
    }
    console.log(editListOfVehicles);
    if ((RoleId == 7 || RoleId == 17) && vendorBasicData) {
      tempcompanyName = vendorBasicData.CompanyName || "";
      temppersonName = `${vendorBasicData.PersonIncharge || ""} ${vendorBasicData.LastNamePersonIncharge || ""
        }`.trim();
      tempcontactNo = vendorBasicData.MobileNo || "";
      tempemail = vendorBasicData.PrimaryEmail || "";
    }
    this.setState({ isLoading: true });
    this.props
      .updateExhibitorExitPass_action(
        ContractorId, editExitHdrId, editExitHdrNo, editListItemsTocarry,
        {
          person:
            ContractorId != null
              ? temppersonName != ""
                ? temppersonName
                : personName
              : exhibitorDetailsData?.["Contact Person"]
                ? exhibitorDetailsData?.["Contact Person"]
                : exhibitorDetailsData?.["PersonName"],
          PrimaryEmail:
            ContractorId != null
              ? tempemail != ""
                ? tempemail
                : email
              : exhibitorDetailsData?.["PrimaryEmail"],
          ExhibitionName: sessionStorage.getItem("ExhibitionName"),
        }, mode, editNoOfVehicles, editListOfVehicles
      )
      .then((data) => {
        if (data.error != 1) {
          if (data.data.length > 0) {
            if (mode == 4) {
              toastSuccess("Material Exit pass saved as draft successfully!");
            } else {
              toastSuccess("Material Exit pass submitted successfully!");
            }
            this.getExhibitorExitPassDetails();
            setTimeout(() => {
              this.setState({
                // companyName: '',
                // personName: '',
                // contactNo: '',
                // email: '',
                // contactNoErr: '',
                // categoryType:
                //   sessionStorage.getItem("RoleIDSS") == 1 ? "Exhibitor" : "contractor",
                // itemToCarryList: [
                //   {
                //     ItemName: "",
                //     Quantity: "",
                //     isFromDb: false,
                //     Nameerr: false,
                //     Quantityerr: false,
                //   },
                // ],
                // editListItemsTocarry: [], editIndex: null, editOpen: false
                editListItemsTocarry: [], editIndex: null, editOpen: false, editListOfVehicles: [], editNoOfVehicles: '', tempMainListOfVehicles: []
              })
              // if (isFullOut) {
              //   this.setState({
              //     isFullOut: false,
              //     itemToCarryList: [
              //       {
              //         ItemName: "",
              //         Quantity: "",
              //         isFromDb: false,
              //         Nameerr: false,
              //         Quantityerr: false,
              //       },
              //     ]
              //   })
              // }
            }, 500);
            this.setState({ isLoading: false });
          }
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });

  }

  submitExhibitorExitPass(mode) {
    const {
      ExitDate,
      ContractorId, noOfVehicles,
      isView,
      categoryType,
      exhibitorDetailsData,
      companyName,
      isFullOut,
      contractorList,
      personName,
      email, vehicleTypeList, listOfVehicles,
      contactNo,
      itemToCarryList,
      emailErr,
      contactNoErr, editOpen,
      RoleId,
      vendorBasicData,
    } = this.state;
    this.inputValidate();
    if (editOpen) {
      toastError("Please cancel the edit Material Exit pass before submitting new")
      return
    }
    for (var i = 0; i < itemToCarryList.length; i++) {
      if (itemToCarryList[i].BalanceQuantity < itemToCarryList[i].Quantity) {
        toastError(
          "Current out qty should be less than or equal to balance qty"
        );
        return;
      }
    }

    if (
      ExitDate != null &&
      (categoryType == "contractor" && ContractorId == 0
        ? companyName != "" &&
        personName != "" &&
        email != "" &&
        contactNo != "" &&
        emailErr == "" &&
        contactNoErr == ""
        : true)
    ) {
      const nonEmptyItems = itemToCarryList.filter(
        (item) =>
          item.Quantity != "" && item.Quantity != null && item.Quantity != 0
      );
      const allnull = itemToCarryList.every(
        (item) =>
          (item.Quantity == "" ||
            item.Quantity == null ||
            item.Quantity == 0) &&
          (item.ItemName == "" || item.ItemName == null || item.ItemName == 0)
      );
      if (allnull) {
        return toastError("Please fill atleast one exit item");
      }
      const allQtynull = itemToCarryList.every(
        (item) =>
          item.Quantity == "" || item.Quantity == null || item.Quantity == 0
      );
      if (allQtynull) {
        return toastError("Please fill atleast one quantity");
      }
      if (nonEmptyItems.length > 0) {
        itemToCarryList.forEach((item) => {
          if (
            item.Quantity != "" &&
            item.Quantity != null &&
            item.Quantity != 0 &&
            item.ItemName.trim() == ""
          ) {
            item.Nameerr = true;
          }
        });
        this.setState({ itemToCarryList: itemToCarryList });
        const condition = nonEmptyItems.some(
          (item) => item.ItemName?.trim() == ""
        );
        if (condition) {
          return toastError("Please fill all item names");
        }
      }
      console.log(nonEmptyItems, "////");

      if (
        categoryType == "contractor" &&
        (ContractorId == "Select" || ContractorId == null) &&
        RoleId != 7 && RoleId != 17
      ) {
        toastError("Please select coordinator");
        return;
      }
      var isDuplicate = false;
      for (var i = 0; i < itemToCarryList.length; i++) {
        for (var j = 0; j < itemToCarryList.length; j++) {
          if (i != j) {
            if (itemToCarryList[i].ItemName == itemToCarryList[j].ItemName) {
              isDuplicate = true;
              break;
            }
          }
        }
      }
      if (isDuplicate) {
        toastError("Duplicate items names is not allowed");
        return;
      }
      const hasItemsFromDb = itemToCarryList.some((item) => item.isFromDb);
      var isNoselect = itemToCarryList.every(
        (item) =>
          item.Quantity == "" || item.Quantity == null || item.Quantity == 0
      );
      if (isNoselect && hasItemsFromDb) {
        toastError("Please input atleast 1 current out qty");
        return;
      }
      var newArr = itemToCarryList.filter(
        (item) =>
          item.Quantity != 0 && item.Quantity != null && item.Quantity != ""
      );
      console.log(ContractorId);
      var tempcompanyName = "";
      var temppersonName = "";
      var tempcontactNo = "";
      var tempemail = "";
      if (ContractorId != null && ContractorId != 0) {
        contractorList.map((item) => {
          if (item.ContractorID == ContractorId) {
            tempcompanyName = item.CompanyName;
            temppersonName = item.PersonName;
            tempcontactNo = item.MobileNo;
            tempemail = item.EmailId;
          }
        });
      }
      if ((RoleId == 7 || RoleId == 17) && vendorBasicData) {
        tempcompanyName = vendorBasicData.CompanyName || "";
        temppersonName = `${vendorBasicData.PersonIncharge || ""} ${vendorBasicData.LastNamePersonIncharge || ""
          }`.trim();
        tempcontactNo = vendorBasicData.MobileNo || "";
        tempemail = vendorBasicData.PrimaryEmail || "";
      }
      console.log('7',
        tempcompanyName, '7', companyName, '7',
        temppersonName, '7', personName, '7',
        tempcontactNo, '7', contactNo, '7',
        tempemail, '7', email,
      )

      // var tempVehicleList = []
      // listOfVehicles.length > 0 && listOfVehicles.map(item => {
      //   if (item.IsOutSelect && !item.IsOut) {
      //     tempVehicleList.push(item)
      //   }
      // })
      if (noOfVehicles == '' || noOfVehicles == null || noOfVehicles < 1) {
        this.setState({
          noOfVehiclesErr: 'Please enter atleast 1 vehicle'
        })
        return toastError("Please enter atleast 1 vehicle");
      }
      console.log(noOfVehicles, 'noOfVehiclesnoOfVehicles')
      if (noOfVehicles != '' && noOfVehicles != null) {
        // return toastError("Please fill Number of Verhicles");
        const condition3 = listOfVehicles.some((item) => item.driverName?.trim() == "");
        if (condition3) {
          return toastError("Please fill all driver names");
        }
        const condition4 = listOfVehicles.some((item) => item.type == '' || item.type == null);
        if (condition4) {
          return toastError("Please select all vehicle types");
        }
        const condition7 = listOfVehicles.some((item) => item.VehicleNo == '' || item.VehicleNo == null);
        if (condition7) {
          return toastError("Please fill all Vehicle No");
        }
        const condition5 = listOfVehicles.some((item) => item.driverNo == '' || item.driverNo == null);
        if (condition5) {
          return toastError("Please fill all driver mobile No");
        }
        const condition6 = listOfVehicles.some((item) => item.driverDocPath == '' && item.driverDocType == '');
        if (condition6) {
          return toastError("Please enter all driver documents");
        }
      }
      const submitCategoryType =
        (RoleId == 7 || RoleId == 17) ? vendorBasicData?.CompanyName || "" : categoryType;
      if (!this.state.IsAgree) {
        toastError("Please agree on exhibition exit rules")
        return
      } else {
        this.setState({ isLoading: true });
        this.props
          .submitExhibitorExitPass_action(
            moment(ExitDate).format("YYYY-MM-DD"),
            submitCategoryType,
            ContractorId,
            tempcompanyName != "" ? tempcompanyName : companyName,
            temppersonName != "" ? temppersonName : personName,
            tempcontactNo != "" ? tempcontactNo : contactNo,
            tempemail != "" ? tempemail : email,
            newArr,
            isFullOut,
            {
              person:
                ContractorId != null
                  ? temppersonName != ""
                    ? temppersonName
                    : personName
                  : exhibitorDetailsData?.["Contact Person"]
                    ? exhibitorDetailsData?.["Contact Person"]
                    : exhibitorDetailsData?.["PersonName"],
              PrimaryEmail:
                ContractorId != null
                  ? tempemail != ""
                    ? tempemail
                    : email
                  : exhibitorDetailsData?.["PrimaryEmail"],
              ExhibitionName: sessionStorage.getItem("ExhibitionName"),
            }, mode, this.state.IsAgree, noOfVehicles, listOfVehicles
          )
          .then((data) => {
            if (data.error != 1) {
              if (data.data.length > 0) {
                if (mode == 4) {
                  toastSuccess("Material Exit pass saved as draft successfully!");
                } else {
                  toastSuccess("Material Exit pass submitted successfully!");
                }
                this.getExhibitorExitPassDetails();
                setTimeout(() => {
                  this.setState({
                    companyName: '',
                    personName: '',
                    contactNo: '',
                    email: '',
                    contactNoErr: '',
                    listOfVehicles: [], noOfVehicles: '', tempMainListOfVehicles: []
                    // categoryType:
                    //   sessionStorage.getItem("RoleIDSS") == 1 ? "Exhibitor" : "contractor",
                    // itemToCarryList: [
                    //   {
                    //     ItemName: "",
                    //     Quantity: "",
                    //     isFromDb: false,
                    //     Nameerr: false,
                    //     Quantityerr: false,
                    //   },
                    // ],
                  })
                  if (isFullOut) {
                    // itemToCarryList.map(item=>{
                    //   item.
                    // })
                    this.setState({
                      isFullOut: false,
                      itemToCarryList: [
                        {
                          ItemName: "",
                          Quantity: "",
                          isFromDb: false,
                          Nameerr: false,
                          Quantityerr: false,
                          // isDelete:false
                        },
                      ]
                    })
                  }
                }, 500);
              }
              // this.setState({ isLoading: false });
              setTimeout(() => {
                if (isView) {
                  this.props.navigate("/accountExitPassList");
                }
              }, 500);
              // this.setState({ isLoading: false });
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      toastError("Please enter mandatory fields!");
    }
  }

  getRandomLightColor() {
    const hue = Math.floor(Math.random() * 360); // any hue
    const saturation = 45 + Math.random() * 15; // 45–60% saturation (soft colors)
    const lightness = 78 + Math.random() * 7; // 78–85% lightness (slightly lighter)
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }

  handleInput = async (e, type, field, index) => {
    const updatedList = structuredClone(this.state.itemToCarryList);
    let Value;
    if (type === "date") {
      Value = e;
    } else if (type === "int") {
      Value = e.target.value.replace(/\D/g, "");
    } else if (type === "checkbox") {
      Value = e.target.checked;
    } else if (type === "file") {
      Value = e.target.files;
    } else {
      Value = e.target.value;
    }

    // --- Subcontractor level update ---
    updatedList[index][field] = Value;
    if (field == "ItemName") {
      updatedList[index].Nameerr = false;
    }
    this.setState({ itemToCarryList: updatedList });
  };

  handleInputEdit = async (e, type, field, index) => {
    const updatedList = structuredClone(this.state.editListItemsTocarry);
    let Value;
    if (type === "date") {
      Value = e;
    } else if (type === "int") {
      Value = e.target.value.replace(/\D/g, "");
    } else if (type === "checkbox") {
      Value = e.target.checked;
    } else if (type === "file") {
      Value = e.target.files;
    } else {
      Value = e.target.value;
    }

    // --- Subcontractor level update ---
    updatedList[index][field] = Value;
    if (field == "ItemName") {
      updatedList[index].Nameerr = false;
    }
    if (field == "Quantity") {
      this.setState({ oldEditQuantity: Value })
    }
    this.setState({ editListItemsTocarry: updatedList });
  };

  removeItem(index) {
    const { itemToCarryList } = this.state;
    const filterArray = itemToCarryList.filter((item, i) => i != index);
    if (filterArray.length == 0) {
      filterArray.push({
        ItemName: "",
        Quantity: "",
        isFromDb: false,
        Nameerr: false,
        Quantityerr: false,
      });
    }
    console.log("filterArray---->", filterArray);
    this.setState({ itemToCarryList: filterArray });
  }

  removeItemEdit(index) {
    const { editListItemsTocarry } = this.state;
    const filterArray = editListItemsTocarry.filter((item, i) => i != index);
    if (filterArray.length == 0) {
      filterArray.push({
        ItemName: "",
        Quantity: "",
        isFromDb: false,
        Nameerr: false,
        Quantityerr: false,
      });
    }
    console.log("filterArray---->", filterArray);
    this.setState({ editListItemsTocarry: filterArray });
  }

  onFullOut() {
    const {
      isLoading,
      isFullOut,
      categoryType,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      extraServices,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      ExitDate,
      totalOutstanding,
      totalPaidAmount,
      totalPayable,
      categoryList,
      isOpen,
      ExitDateErr,
      RoleId,
    } = this.state;
    itemToCarryList.length > 0 &&
      itemToCarryList.map((item) => {
        item.Quantity = item.BalanceQuantity;
      });
    this.setState({ isFullOut: true, itemToCarryList: itemToCarryList });
  }
  onPOut() {
    const {
      isLoading,
      isFullOut,
      categoryType,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      extraServices,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      ExitDate,
      totalOutstanding,
      totalPaidAmount,
      totalPayable,
      categoryList,
      isOpen,
      ExitDateErr,
      RoleId,
    } = this.state;
    itemToCarryList.length > 0 &&
      itemToCarryList.map((item) => {
        item.Quantity = "";
      });
    this.setState({ isFullOut: false, itemToCarryList: itemToCarryList });
  }

  maxLengthCheck = (object, maxLength) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  copyToClipboard = (UUID, i) => {
    const {
      isLoading,
      categoryType,
      copiedIndex,
      exhUUID,
      isCopied,
      isCopyModal,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      ExitDate,
      categoryList,
      isOpen,
      ExitDateErr,
      RoleId,
    } = this.state;
    console.log(UUID, i);
    const link = `${link_BASE_URL}exitPass/${UUID}/${sessionStorage.getItem(
      "sessionExhibitionID"
    )}/${exhUUID}`; // you can replace this

    // navigator.clipboard.writeText(link).then(() => {
    //     this.setState({ isCopied: true, copiedIndex: i });

    //     // reset message after 2 sec
    //     setTimeout(() => this.setState({ isCopied: false, copiedIndex: '' }), 2000);
    // });
    // navigator.clipboard.writeText(link).then(() => {

    //     // reset message after 2 sec
    //     setTimeout(() => this.setState({ isCopied: false, copiedIndex: '' }), 2000);
    // });
    this.setState({ isCopied: true, copiedIndex: i });

    // const handleCopy = () => {
    const textArea = document.createElement("textarea");
    textArea.value = link;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    // alert("Link copied!");
    setTimeout(() => this.setState({ isCopied: false, copiedIndex: "" }), 2000);

    // };
  };

  getVendorBasicDetails() {
    const userId = JSON.parse(sessionStorage.getItem("loginDataSS")).UserID;
    this.props
      .getVendorBasicDetail_action(userId)
      .then((data) => {
        if (
          data.error != 1 &&
          data.data.vendorBasicDetail &&
          data.data.vendorBasicDetail.length > 0
        ) {
          const vendorData = data.data.vendorBasicDetail[0];
          this.setState({
            vendorBasicData: vendorData,
            exhibitorDetailsData: {
              ExhCompanyName: vendorData.CompanyName,
              "Contact Person": `${vendorData.PersonIncharge} ${vendorData.LastNamePersonIncharge}`,
              MobileNo: vendorData.MobileNo,
              PrimaryEmail: vendorData.PrimaryEmail,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onWaiveClick() {
    const {
      isLoading,
      isFullOut,
      exitPassId,
      categoryType,
      isCopied,
      isCopyModal,
      copiedIndex,
      isDirectContractor,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      extraServices,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      ExitDate,
      totalOutstanding,
      totalPaidAmount,
      totalPayable,
      categoryList,
      isOpen,
      ExitDateErr,
      RoleId,
      REcompanyName,
      REcontactNo,
      REemailID,
      REpersonName,
      RSPcompanyName,
      RSPcontactNo,
      RSPemailID,
      RSPpersonName,
      REcompanyNameErr,
      REcontactNoErr,
      REemailIDErr,
      REpersonNameErr,
      RSPcompanyNameErr,
      RSPcontactNoErr,
      RSPemailIDErr,
      RSPpersonNameErr,
      isWaiverOn,
      inputOTP,
      approvedByName,
      remark, ExitNo, adminEmail, adminUserId
    } = this.state;
    if (isWaiverOn) {
      this.setState({
        isWaiverOn: false,
        inputOTPErr: "",
        approvedByNameErr: "",
        otpValid: false,
        inputOTP: "",
      });
    } else {
      var tablerows = `<tr>
                                <td><strong>Sr. No</strong></td>
                                <td style="text-align: left;"><strong>Company Name</strong></td>
                                <td><strong>Contact Person</strong></td>
                                <td><strong>Hall No / Booth No</strong></td>
                                <td><strong>Service</strong></td>
                                <td><strong>Total Payable Amount</strong></td>
                                <td><strong>Paid Amount</strong></td>
                                <td><strong>Outstanding</strong></td>
                                </tr>`
      extraServices.length > 0 && extraServices.map((item, k) => {
        var newrows = `
                                    <tr>
                                    <td><strong>${k + 1}</strong></td>
                                    <td style="text-align: left;">${exhibitorDetailsData?.["ExhCompanyName"]}</td>
                                    <td>${exhibitorDetailsData?.["Contact Person"] ||
          exhibitorDetailsData?.["PersonName"]}</td>
                                   <td>
                                    ${exhibitorDetailsData["Hall No"] != null && exhibitorDetailsData["Hall No"] != '' && exhibitorDetailsData["Stall No"] != null && exhibitorDetailsData["Stall No"] != '' ? `${exhibitorDetailsData["Hall No"]} / ${exhibitorDetailsData["Stall No"]}` : '-'}</td>
                                       <td>${item.Service}</td>
                                    <td>${item.TotalPayable.toLocaleString(
            "en-IN"
          )}</td>
                                    <td>${item.PaidAmount}</td>
                                    <td>${item.Outstanding}</td>
                                    </tr>`
        tablerows = tablerows + newrows
      })
      var totalTd = `<tr>
                                <td colspan="5"> <strong>Total</strong></td>
                                <td><strong>${totalPayable.toLocaleString("en-IN")}</strong></td>
                                <td><strong>${totalPaidAmount.toLocaleString("en-IN")}</strong></td>
                                <td><strong>${totalOutstanding.toLocaleString("en-IN")}</strong></td>
                                </tr>`
      tablerows = tablerows + totalTd

      var tempExNo = JSON.parse(JSON.stringify(ExitNo))
      if (tempExNo.includes('/')) {
        tempExNo = tempExNo.replace("/", "-")
      }
      if (tempExNo.includes('/')) {
        tempExNo = tempExNo.replace("/", "-")
      }
      const approveUrl = `${link_BASE_URL}exitPassWaiveOff/${exitPassId}&&${tempExNo}`
      // console.log(` `)
      this.setState({ isLoading: true });
      this.setState({ isWaiverOn: true });
      this.props
        .insertExitPassOTP_action(exitPassId, tablerows, approveUrl, ExitNo, sessionStorage.getItem("firstNameSS"), adminEmail, adminUserId, `${sessionStorage.getItem("ApplicationDataSS") != null ? JSON.parse(sessionStorage.getItem("ApplicationDataSS")).CurrencyID == 1 ? `₹ ${extraServices[extraServices.length - 1].Outstanding.toLocaleString("en-IN")}` : `$ ${extraServices[extraServices.length - 1].Outstanding.toLocaleString("en-IN")}` : `₹ ${extraServices[extraServices.length - 1].Outstanding.toLocaleString("en-IN")}`} `)
        .then((data) => {
          if (data.error != 1) {
            setTimeout(() => {
              this.setState({ isLoading: false, approvalStatus: "Waiting for Approval" });
            }, 2500);
            toastSuccess("Approval mail sent to admin");
            this.startInterval()
            this.setState({
              isWaiverOn: true,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  onSendOTP() {
    const {
      isLoading,
      isFullOut,
      categoryType,
      exitPassId,
      isCopied,
      isCopyModal,
      copiedIndex,
      isDirectContractor,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      extraServices,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      ExitDate,
      totalOutstanding,
      totalPaidAmount,
      totalPayable,
      categoryList,
      isOpen,
      ExitDateErr,
      RoleId,
      REcompanyName,
      REcontactNo,
      REemailID,
      REpersonName,
      RSPcompanyName,
      RSPcontactNo,
      RSPemailID,
      RSPpersonName,
      REcompanyNameErr,
      REcontactNoErr,
      REemailIDErr,
      REpersonNameErr,
      RSPcompanyNameErr,
      RSPcontactNoErr,
      RSPemailIDErr,
      RSPpersonNameErr,
      isWaiverOn,
      inputOTP,
      approvedByName,
      remark,
    } = this.state;
    this.setState({ isLoading: true });
    this.props
      .insertExitPassOTP_action(exitPassId)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess("OTP sent to admin");
          this.setState({
            isWaiverOn: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  checkOTP() {
    const {
      isLoading,
      isFullOut,
      categoryType,
      isCopied,
      isCopyModal,
      copiedIndex,
      isDirectContractor,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      extraServices,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      ExitDate,
      totalOutstanding,
      totalPaidAmount,
      totalPayable,
      categoryList,
      isOpen,
      ExitDateErr,
      RoleId,
      REcompanyName,
      REcontactNo,
      REemailID,
      REpersonName,
      RSPcompanyName,
      RSPcontactNo,
      RSPemailID,
      RSPpersonName,
      REcompanyNameErr,
      REcontactNoErr,
      REemailIDErr,
      REpersonNameErr,
      RSPcompanyNameErr,
      RSPcontactNoErr,
      RSPemailIDErr,
      RSPpersonNameErr,
      isWaiverOn,
      inputOTP,
      approvedByName,
      remark,
      exitPassId,
      otpValid,
    } = this.state;
    this.setState({ isLoading: true });
    this.props
      .verifyExitPassOTP_action(inputOTP, exitPassId)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess("OTP verified successfully");
          this.setState({
            otpValid: true,
          });
        } else {
          toastError("Invalid OTP");
          this.setState({ isLoading: false });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  checkApproval() {
    const {
      isLoading,
      isFullOut,
      categoryType,
      isCopied,
      isCopyModal,
      copiedIndex,
      isDirectContractor,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      extraServices,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      ExitDate,
      totalOutstanding,
      totalPaidAmount,
      totalPayable,
      categoryList,
      isOpen,
      ExitDateErr,
      RoleId,
      REcompanyName,
      REcontactNo,
      REemailID,
      REpersonName,
      RSPcompanyName,
      RSPcontactNo,
      RSPemailID,
      RSPpersonName,
      REcompanyNameErr,
      REcontactNoErr,
      REemailIDErr,
      REpersonNameErr,
      RSPcompanyNameErr,
      RSPcontactNoErr,
      RSPemailIDErr,
      RSPpersonNameErr,
      isWaiverOn,
      inputOTP,
      approvedByName,
      remark,
      exitPassId,
      otpValid,
    } = this.state;
    // this.setState({ isLoading: true });
    this.props
      .checkIfApproved_action(exitPassId)
      .then((data) => {
        if (data.error != 1) {
          // this.setState({ isLoading: false });
          // toastSuccess("OTP verified successfully");
          // this.setState({
          //   otpValid: true,
          // });
        } else {
          // toastError("Invalid OTP");
          // this.setState({ isLoading: false });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  setOldQty() {
    const { ExitNo, editListItemsTocarry, } = this.state
    editListItemsTocarry.map(item => {
      item.oldEditQuantity = item.Quantity
    })
    this.setState({ editListItemsTocarry: editListItemsTocarry })
    setTimeout(() => {
      console.log(editListItemsTocarry)
    }, 1000);
  }

  onChangeEditNoOFVehicles(value) {
    const {
      editOpen, editIndex, editListOfVehicles, listOfVehicles,
      isLoading, deletePop, vehicleTypeList, editNoOfVehiclesErr, tempListOfVehicles,
      categoryType, noOfVehiclesErr, editNoOfVehicles } = this.state
    var tempList = []
    console.log('lllllllllllllllllllllllllllllllllllll', value)
    for (var i = 0; i < value; i++) {
      console.log(tempListOfVehicles[i])
      if (tempListOfVehicles[i] != undefined) {
        tempList.push(tempListOfVehicles[i])
      } else {
        tempList.push({ VehicleTypeID: '', DriverName: '', DriverMobNo: '', VehicleNo: '', driverDocFile: '', DriverDocument: '', ExitVehicleDtlID: '', driverDocName: '', driverDocType: '' })
      }
    }
    this.setState({ editListOfVehicles: tempList })
  }
  onChangeNoOFVehicles(value) {
    const {
      editOpen, editIndex, editListOfVehicles, listOfVehicles, mainListOfVehicles, tempMainListOfVehicles,
      isLoading, deletePop, vehicleTypeList, editNoOfVehiclesErr, tempListOfVehicles,
      categoryType, noOfVehiclesErr, editNoOfVehicles } = this.state
    var tempList = []
    console.log('lllllllllllllllllllllllllllllllllllll', tempMainListOfVehicles, value)
    for (var i = 0; i < value; i++) {
      console.log(tempMainListOfVehicles[i])
      if (tempMainListOfVehicles[i] != undefined) {
        tempList.push(tempMainListOfVehicles[i])
      } else {
        tempList.push({
          VehicleNo: '', type: '', driverName: '', driverNo: '', driverDocFile: '', driverDocPath: '', driverDocName: '', driverDocType: ''
        })
      }
    }
    this.setState({ listOfVehicles: tempList })
  }


  renderNewImage = (img, type) => {
    const { imageBase64 } = this.state;
    if (type == 'pdf') {
      // window.open(img, "_blank")

      const base64 = img;
      const pdfData = atob(base64.split(",")[1]); // decode Base64

      const len = pdfData.length;
      const uintArray = new Uint8Array(new ArrayBuffer(len));
      for (let i = 0; i < len; i++) {
        uintArray[i] = pdfData.charCodeAt(i);
      }

      const blob = new Blob([uintArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      window.open(url, "_blank"); // open in new tab

    } else {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(
          `<img src="${img}" style="width:100%;height:auto;" />`
        );
      } else {
        alert("Please allow popups for this website");
      }
    }
  };

  onFilePick = async (e, file, i) => {
    e.preventDefault()
    const { exhibitDetailsList, tempFilePath, listOfVehicles } = this.state
    // console.log("File01010101------", file, key)
    const { } = this.state
    console.log(file, document.getElementById(`file${i}`), tempFilePath)
    if (file.length != 0) {
      if (file[0]['size'] >= 5 * 1024 * 1024) {
        toastError('File size more than 5mb are not allow.')
      } else {
        var image = '';
        if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
          file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
          file[0]['name'].toString().toLowerCase().includes('.png') ||
          file[0]['name'].toString().toLowerCase().includes('.jpg')
        ) {

          if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
          ) {
            image = await this.resizeFile(file[0]);
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            listOfVehicles[i].driverDocFile = image
            listOfVehicles[i].driverDocName = file[0]['name'].toString()
            //     visitorGroupList[i].passportFileErr = ''
            this.setState({ listOfVehicles: listOfVehicles })
            // } else {
            // this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString() })
            // }

          }
          else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
            image = await this.onPdfSelect(file[0]);
            // if (key == 1) {
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            listOfVehicles[i].driverDocFile = image
            listOfVehicles[i].driverDocName = file[0]['name'].toString()
            this.setState({ listOfVehicles: listOfVehicles })
            // } else {
            // this.setState({ passportFile: image, passportFileErr: "" })
            // }
            // this.setState({ passportFile: image, passportFileErr: "" })

          }

          var fileType = file[0]['type']
          var fileTypeList;
          if (fileType.includes("/")) {
            fileTypeList = fileType.split("/")
          }
          // if (sessionStorage.getItem('VisitorTypeID') == 2) {
          //     visitorGroupList[i].passportFileType = fileTypeList.length > 0 ? fileTypeList[1] : ""
          //     this.setState({ visitorGroupList: visitorGroupList })
          // } else {
          listOfVehicles[i].driverDocType = fileTypeList.length > 0 ? fileTypeList[1] : ""
          // document.getElementById(`file${i}`).value = document.getElementById(`file${i}`).value

          // this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
          // }
        } else {
          toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')

          // if (key == 1) {
          //     this.setState({ passportFile: "" })
          //     document.getElementById("passportFile").value = ""
          // } else if (key == 2) {
          //     this.setState({ visitorLetterFile: "" })
          //     document.getElementById("visitorLetter").value = ""
          // }
        }
      }
    } else {
      //     exhibitDetailsList[i].DocumentType = ''
      //     exhibitDetailsList[i].DocumentFile = ''
      //     exhibitDetailsList[i].DocumentName = ''
      //     this.setState({ exhibitDetailsList: exhibitDetailsList })
    }
  }

  // If Pdf is selected in file
  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  // File resize
  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        'JPEG',
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300,
      );
    });

  onVehicleDocDelete(id, i) {
    const { isDel3Open, exhibitDetailsList, listOfVehicles } = this.state
    console.log(id)
    // if (!listOfVehicles[i].DocDeleted) {
    //   this.setState({ isDel3Open: !isDel3Open, delChapterID: id })
    // } else {
    listOfVehicles[i].driverDocType = ''
    listOfVehicles[i].driverDocFile = ''
    listOfVehicles[i].driverDocName = ''
    this.setState({ listOfVehicles: listOfVehicles })
    // }

  }

  onEditFilePick = async (e, file, i) => {
    e.preventDefault()
    const { exhibitDetailsList, editListOfVehicles, tempFilePath, listOfVehicles } = this.state
    // console.log("File01010101------", file, key)
    const { } = this.state
    console.log(file, document.getElementById(`file${i}`), tempFilePath)
    if (file.length != 0) {
      if (file[0]['size'] >= 5 * 1024 * 1024) {
        toastError('File size more than 5mb are not allow.')
      } else {
        var image = '';
        if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
          file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
          file[0]['name'].toString().toLowerCase().includes('.png') ||
          file[0]['name'].toString().toLowerCase().includes('.jpg')
        ) {

          if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
          ) {
            image = await this.resizeFile(file[0]);
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            editListOfVehicles[i].driverDocFile = image
            editListOfVehicles[i].driverDocName = file[0]['name'].toString()
            //     visitorGroupList[i].passportFileErr = ''
            this.setState({ editListOfVehicles: editListOfVehicles })
            // } else {
            // this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString() })
            // }

          }
          else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
            image = await this.onPdfSelect(file[0]);
            // if (key == 1) {
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            editListOfVehicles[i].driverDocFile = image
            editListOfVehicles[i].driverDocName = file[0]['name'].toString()
            this.setState({ editListOfVehicles: editListOfVehicles })
            // } else {
            // this.setState({ passportFile: image, passportFileErr: "" })
            // }
            // this.setState({ passportFile: image, passportFileErr: "" })

          }

          var fileType = file[0]['type']
          var fileTypeList;
          if (fileType.includes("/")) {
            fileTypeList = fileType.split("/")
          }
          // if (sessionStorage.getItem('VisitorTypeID') == 2) {
          //     visitorGroupList[i].passportFileType = fileTypeList.length > 0 ? fileTypeList[1] : ""
          //     this.setState({ visitorGroupList: visitorGroupList })
          // } else {
          editListOfVehicles[i].driverDocType = fileTypeList.length > 0 ? fileTypeList[1] : ""
          // document.getElementById(`file${i}`).value = document.getElementById(`file${i}`).value

          // this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
          // }
        } else {
          toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')

          // if (key == 1) {
          //     this.setState({ passportFile: "" })
          //     document.getElementById("passportFile").value = ""
          // } else if (key == 2) {
          //     this.setState({ visitorLetterFile: "" })
          //     document.getElementById("visitorLetter").value = ""
          // }
        }
      }
    } else {
      //     exhibitDetailsList[i].DocumentType = ''
      //     exhibitDetailsList[i].DocumentFile = ''
      //     exhibitDetailsList[i].DocumentName = ''
      //     this.setState({ exhibitDetailsList: exhibitDetailsList })
    }
  }

  // If Pdf is selected in file
  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  // File resize
  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        'JPEG',
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300,
      );
    });

  onEditVehicleDocDelete(id, i) {
    const { isDel3Open, exhibitDetailsList, editListOfVehicles, listOfVehicles } = this.state
    console.log(id)
    if (!editListOfVehicles[i].driverDocdeleted) {
    }
    else {
      editListOfVehicles[i].driverDocType = ''
      editListOfVehicles[i].driverDocFile = ''
      editListOfVehicles[i].driverDocName = ''
      editListOfVehicles[i].driverDocPath = ''

      this.setState({ editListOfVehicles: editListOfVehicles })
    }

  }

  render() {
    const { ExitNo, editListItemsTocarry, isOpenConfirmationModal,
      isLoading, deletePop, listOfVehicles, noOfVehicles,
      ExitPassStatus, IsAgree, vehicleTypeList, tempListOfVehicles,
      rejectReasonModal,
      isApproved, noOfVehiclesErr,
      refuseModal, editNoOfVehicles,
      editNoOfVehiclesErr,
      tempMainListOfVehicles,
      mainListOfVehicles,
      isFullOut,
      categoryType,
      otpValid,
      isCopied,
      isCopyModal, editListOfVehicles,
      copiedIndex,
      isDirectContractor,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      extraServices,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      ExitDate,
      totalOutstanding,
      totalPaidAmount,
      totalPayable,
      categoryList,
      isOpen,
      ExitDateErr,
      RoleId,
      REcompanyName,
      REcontactNo,
      REemailID,
      REpersonName,
      RSPcompanyName,
      RSPcontactNo,
      RSPemailID, IsNDCIssued,
      RSPpersonName,
      REcompanyNameErr,
      REcontactNoErr,
      REemailIDErr,
      toShowPay,
      REpersonNameErr,
      RSPcompanyNameErr,
      RSPcontactNoErr,
      RSPemailIDErr,
      RSPpersonNameErr,
      isWaiverOn,
      inputOTP,
      approvedByName,
      remark,
      vendorBasicData,
      isVendor,
      ITMEStaffName,
      ITMEStaffNameErr,
      IssuedDate,
      IssuedDateErr, editOpen, editIndex,
      showVideoModal, adminEmail, adminUserId, showExitPass
    } = this.state;
    console.log((sessionStorage.getItem('RoleIDSS') == 2 || sessionStorage.getItem('RoleIDSS') == 6 || sessionStorage.getItem('RoleIDSS') == 9), '/////',
      vendorBasicData != null && {
        person: `${vendorBasicData.PersonIncharge || ""} ${vendorBasicData.LastNamePersonIncharge || ""
          }`.trim(),
        PrimaryEmail: vendorBasicData.PrimaryEmail,
        ExhibitionName: sessionStorage.getItem("ExhibitionName"),
      },
      {
        person: exhibitorDetailsData?.["Contact Person"],
        PrimaryEmail: exhibitorDetailsData?.["PrimaryEmail"],
        ExhibitionName: sessionStorage.getItem("ExhibitionName"),
      },
      exhibitorDetailsData,
      'ggggg', extraServices,
      extraServices.length > 0,
      !isDirectContractor,
      !isApproved
    );
    var isNational = exhibitorDetailsData?.["MobileNo"]?.slice(0, 3) == '+91'
    setTimeout(() => {
      console.log(itemToCarryList, categoryList, adminUserId, tempListOfVehicles)
    }, 1000);
    var isAll0 = itemToCarryList.every((obj) => obj.isDelete == undefined);
    var loadexitpass = totalOutstanding == 0 && IsNDCIssued
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {(isVendor == 1 || RoleId == 7 || RoleId == 17 || RoleId == 1) && showVideoModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => this.setState({ showVideoModal: false })}>
            <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Material Exit pass</h5>
                  <button type="button" className="btn-close" onClick={() => this.setState({ showVideoModal: false })}></button>
                </div>
                <div className="modal-body">
                  <video controls autoPlay style={{ width: '100%' }}>
                    <source src={RoleId == 1 ? "/assets/ExhibitorExitPass.mp4" : "/assets/VendorExitPass.mp4"} type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* {
        )} */}
        {RoleId == 1 ? (
          <ExhibitorHeader />
        ) : RoleId == 2 || RoleId == 6 || RoleId == 9 || RoleId == 7 || RoleId == 17 ? (
          <HeaderWithLogo />
        ) : (
          <AdminHeader />
        )}

        {RoleId == 1 ? (
          <ExhibitorDrawer />
        ) : RoleId == 7 || RoleId == 17 ? (
          <VendorDrawer />
        ) : (
          (RoleId == 2 || RoleId == 6 || RoleId == 9) && <AdminDrawer />
        )}
        {/*app-content open*/}
        <div className="page" style={{ justifyContent: 'normal' }}>
          {/* <div className="page-main"> */}
          <div className={RoleId != 7 && RoleId != 17 && RoleId != null && RoleId != 16 ? "with-dr-container" : ""}>
            {/* <div class="row m-0">
              {RoleId != 7 && (
                <div className="breadcrumb-scroll-fixed">
                  <h6 class="mb-0 p-2 text-white">
                    {isView
                      ? "Material Exit pass"
                      : isDirectContractor
                        ? "Contractor Exit  Pass"
                        : "Exhibitor Material Exit pass"}


                  </h6>
                </div>
              )}
            </div> */}
            {/* <div
              className={`main-content ${RoleId == 2 || RoleId == 7 || RoleId == 6 || RoleId == 9 || RoleId == 16
                ? "tab-space"
                : RoleId == 1
                  ? "exb-top-space"
                  : ""
                }`}
            > */}
            <div
              className={`main-content ${RoleId == 2 || RoleId == 7 || RoleId == 17 || RoleId == 6 || RoleId == 9 || RoleId == 16
                ? "vendor-top-space"
                : RoleId == 1
                  ? "exb-top-space"
                  : ""
                }`}
              style={{ marginTop: RoleId == null ? '7.5rem' : '' }}
            >
              {RoleId == 1 && (
                <div className="">
                  <div className="row">
                    <ExhibitorTopMenu />
                  </div>
                </div>
              )}

              {(sessionStorage.getItem("RoleIDSS") == 1 ? loadexitpass : showExitPass) ?
                <div className="text-center text-aqua">

                  {/* The Material Entry pass will be enabled only after the organizer approves the No Dues Certificate. */}

                  <div className="container-fluid min-vh-90 d-flex justify-content-center align-items-center mt-5">
                    <div className="">

                      {/* Pending Icon */}
                      <div className="icon-wrapper mx-auto mb-3">
                        <svg
                          width="36"
                          height="36"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ffffff"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="12" r="9" />
                          <path d="M12 7v5l3 3" />
                        </svg>

                      </div>

                      {/* Title */}
                      <h4 className="text-aqua mb-3 fw-semibold">
                        Comming Soon
                      </h4>

                      {/* Info Text */}
                      {/* <h6 className="mb-0 text-center">
                        The Material Exit pass will be enabled only after the 100% payment towards Space Booking and after the organizer approves the No Dues Certificate.
                      </h6> */}
                    </div>
                  </div>

                </div>
                :
                (this.state.showEntryPassWarning && !isView) ?
                  <div className="text-center text-aqua">

                    {/* The Material Entry pass will be enabled only after the organizer approves the No Dues Certificate. */}

                    <div className="container-fluid min-vh-90 d-flex justify-content-center align-items-center mt-5">
                      <div className="mt-4">

                        {/* Pending Icon */}
                        <div className="icon-wrapper mx-auto mb-3">
                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ffffff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <circle cx="12" cy="12" r="9" />
                            <path d="M12 7v5l3 3" />
                          </svg>

                        </div>

                        {/* Title */}
                        <h4 className="text-aqua mb-3 fw-semibold">
                          Material Entry pass Required
                        </h4>

                        {/* Info Text */}
                        <h6 className="mb-0 text-center">
                          Please fill Material Entry pass first before creating Material Exit pass
                        </h6>
                      </div>
                    </div>

                  </div> :
                  <section className="p-3 pt-0 text-left">
                    {!isView && !isDirectContractor && (
                      <div className="d-flex justify-content-end mb-1 px-0 text-aqua pt-3 gap-2" style={{ marginTop: '10px' }}>
                        {isVendor != 1 && RoleId != 7 && RoleId != 17 && (
                          <span
                            className="fw-bold"
                            onClick={() => this.setState({ isCopyModal: true })}
                            style={{ cursor: "pointer", marginTop: '2px' }}
                          >
                            <i className="text-decoration-none text-aqua fw-bold"></i>
                            Share Link to Contractor &nbsp; |&nbsp;
                          </span>
                        )}
                        {/* {(isVendor == 1 || RoleId == 7 || RoleId == 1) && (
                          {/* <span
                            onClick={() => this.setState({ showVideoModal: true })}
                            style={{ cursor: 'pointer', color: '#3dbca7', fontSize: '16px' }}
                          >
                            <i className="bi bi-play-circle-fill me-2"></i>
                            User Manual
                          </span> */}
                      </div>
                    )}
                    <div className="row m-0">
                      <div className="col-md-8 p-0">
                        <div className="row py-2 pb-0">
                          <div className="col-md-4 mb-2">
                            <label className="text-muted d-block fw-normal">
                              {/* {RoleId == 7 || isVendor == 1
                            ? "Service Partner Name"
                            : "Exhibitor Name"} */}
                              Company Name
                            </label>
                            <span className="fw-semibold">
                              {exhibitorDetailsData?.["ExhCompanyName"]}
                            </span>
                          </div>
                          {RoleId != 7 && RoleId != 17 && isVendor != 1 && (
                            <div className="col-md-4 mb-2">
                              <label className="text-muted d-block fw-normal">
                                Hall No / Booth No
                              </label>
                              {exhibitorDetailsData["Hall No"] != null && exhibitorDetailsData["Hall No"] != '' && exhibitorDetailsData["Stall No"] != null && exhibitorDetailsData["Stall No"] != '' ?
                                <span className="fw-semibold">
                                  {exhibitorDetailsData["Hall No"] != null && exhibitorDetailsData["Hall No"] != '' ? exhibitorDetailsData["Hall No"] : '-'} /{" "}
                                  {exhibitorDetailsData["Stall No"] != null && exhibitorDetailsData["Stall No"] != '' ? exhibitorDetailsData["Stall No"] : '-'}
                                </span> : <span className="fw-semibold">-</span>}
                            </div>
                          )}
                          <div className="col-md-4 mb-2">
                            <label className="text-muted d-block fw-normal">
                              Contact Person
                            </label>
                            <span className="fw-semibold">
                              {exhibitorDetailsData?.["Contact Person"] ||
                                exhibitorDetailsData?.["PersonName"]}
                            </span>
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="text-muted d-block fw-normal">
                              Mobile No
                            </label>
                            <span className="fw-semibold">
                              {exhibitorDetailsData?.["MobileNo"]}
                            </span>
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="text-muted d-block fw-normal">
                              Email
                            </label>
                            <span className="fw-semibold">
                              {exhibitorDetailsData?.["PrimaryEmail"]}
                            </span>
                          </div>
                        </div>
                      </div>
                      {RoleId != 7 && RoleId != 17 && isVendor != 1 && (
                        <div className="col-md-4 text-center">
                          <img
                            src={
                              exhibitorDetailsData?.["isNodueIssued"] == 1
                                ? "images/no-dues-issued.png"
                                : "images/no-dues-pending.png"
                            }
                            className="img-responsive m-auto d-block mt-2 mb-2"
                            style={{ width: 150 }}
                          />
                        </div>
                      )}
                    </div>
                    {console.log('categoryListcategoryList', categoryList)}
                    {categoryList.length > 0 && (
                      <div className="row mx-0 mt-2">
                        <div className="entry-pass-row border rounded-2 bg-light p-2 mb-1">
                          <h6 className="entry-pass-title">Previous Material Exit passes</h6>
                          <div className="p-0">
                            {/* <div className="select-details"> */}
                            {
                              categoryList.length > 0 &&
                              categoryList.map((item, i) => (
                                <div
                                  className="accordion w-100"
                                  id="exitAccordion"
                                >
                                  <div className="accordion-item border-0">
                                    <h2
                                      className="accordion-header"
                                      id="headingOne"
                                      style={{ position: "relative" }}
                                    >
                                      {/* <button
                                    className={editOpen ? editIndex == i ? "accordion-button d-flex align-items-center justify-content-between p-1 border rounded-0" : "accordion-button collapsed d-flex align-items-center justify-content-between p-1 border rounded-0" : "accordion-button collapsed d-flex align-items-center justify-content-between p-1 border rounded-0"}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseOne_${i}`}
                                    aria-expanded={isView ? true : editOpen ? editIndex == i ? true : false : false}
                                    aria-controls={`collapseOne_${i}`}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span className="text-muted  px-2 border-end fw-semibold">
                                        <i className="fa fa-calendar-o me-1 grid-icon" />
                                        {moment(item.ExitDate).format(
                                          "DD MMM YYYY"
                                        )}
                                      </span>
                                      <span
                                        className={
                                          categoryType === "contractor"
                                            ? "text-muted  px-2 border-end pt-1"
                                            : "px-2 fw-normal"
                                        }
                                      >
                                        <i className="bi bi-door-closed-fill me-1 grid-icon" />
                                      
                                        {item.ExitNo}
                                      </span>
                                      {categoryType === "contractor" && (
                                        <>
                                          <span className="text-muted px-2 fw-normal">
                                            <i className="ri-hotel-line me-1 grid-icon" />
                                            {item.CompanyName}
                                          </span>
                                        </>
                                      )}
                                    </div>
                                  </button> */}

                                      <button
                                        className={`accordion-button ${editOpen && editIndex == i ? "" : "collapsed"} 
  d-flex flex-column flex-md-row align-items-start align-items-md-center 
  justify-content-between p-2 border rounded-0`}
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapseOne_${i}`}
                                        aria-expanded={
                                          isView ? true : editOpen ? editIndex == i : false
                                        }
                                        aria-controls={`collapseOne_${i}`}
                                      >
                                        <div className="d-flex flex-column flex-md-row w-100">

                                          {/* Date */}
                                          <span className="text-muted px-md-2 mb-1 mb-md-0 fw-semibold border-md-end">
                                            <i className="fa fa-calendar-o me-1 grid-icon" />
                                            {moment(item.ExitDate).format("DD MMM YYYY")}
                                          </span>

                                          {/* Exit No */}
                                          <span className="px-md-2 mb-1 mb-md-0 fw-normal">
                                            <i className="bi bi-door-closed-fill me-1 grid-icon" />
                                            {item.ExitNo}
                                          </span>

                                          {/* Company */}
                                          {categoryType === "contractor" && (
                                            <span className="text-muted px-md-2 fw-normal">
                                              <i className="ri-hotel-line me-1 grid-icon" />
                                              {item.CompanyName}
                                            </span>
                                          )}

                                        </div>
                                      </button>

                                      {(sessionStorage.getItem('RoleIDSS') == 2 || sessionStorage.getItem('RoleIDSS') == 6 || sessionStorage.getItem('RoleIDSS') == 9) ? <></> : item.StatusID == 4 ? editIndex != i && <div className="d-flex">
                                        {/* <div> */}
                                        {/* <span className="text-muted px-2 border-end text-success">
                                                                Approved
                                                            </span> */}
                                        {/* </div> */}
                                        <div className="d-flex align-items-center icon-header mb-1 action-icons"
                                          style={{
                                            fontFamily: "sans-serif",
                                            scale: "0.6",
                                            marginTop: "-7px",
                                            right: '0px',
                                            zIndex: 20,
                                          }}>
                                          {console.log(categoryList, 'cat')}
                                          <button
                                            type="button"
                                            className="btn border-end"
                                            onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Update?', buttonName: 'Update', action: 0 }, popArg: [i, item.itemToCarryList, item.ExhExitPassHdrID, item.ExitNo, item.vehicleList, item.NoOfVehicle, 1] })}
                                          // onClick={() =>
                                          //   this.setState(
                                          //     {
                                          //       editIndex: i,
                                          //       editListItemsTocarry: item.itemToCarryList,
                                          //       editExitHdrId: item.ExhExitPassHdrID,
                                          //       editExitHdrNo: item.ExitNo,
                                          //     },
                                          //     () => this.updateExhibitorExitPass(1)

                                          //   )
                                          // }
                                          >
                                            <span class="material-symbols-outlined save-draft-icon" title="Submit">check_circle</span>
                                          </button>

                                          <button
                                            type="button"
                                            className="btn border-end mx-2"
                                            onClick={() =>
                                              this.setState({ editIndex: i, editOpen: true, editListItemsTocarry: item.itemToCarryList, editExitHdrId: item.ExhExitPassHdrID, editExitHdrNo: item.ExitNo, editListOfVehicles: JSON.parse(JSON.stringify(item.vehicleList)), editNoOfVehicles: item.NoOfVehicle, tempListOfVehicles: JSON.parse(JSON.stringify(item.vehicleList)), mainListOfVehicles: JSON.parse(JSON.stringify(item.vehicleList)), }, () => console.log(item))
                                            }
                                          // onClick={() =>
                                          //   this.setState(
                                          //     {
                                          //       editIndex: i,
                                          //       editOpen: true,
                                          //       editListItemsTocarry: item.itemToCarryList,
                                          //       editExitHdrId: item.ExhExitPassHdrID,
                                          //       editExitHdrNo: item.ExitNo,
                                          //     },
                                          //     () => this.setOldQty()
                                          //   )
                                          // }
                                          >
                                            <span class="material-symbols-outlined save-draft-icon" title="Edit">edit</span>
                                          </button>

                                          <button
                                            type="button"
                                            className="btn "
                                            onClick={() =>
                                              this.setState({
                                                editListItemsTocarry: item.itemToCarryList,
                                                editExitHdrId: item.ExhExitPassHdrID,
                                                editExitHdrNo: item.ExitNo,
                                                deletePop: true,
                                              })
                                            }
                                          >
                                            <span class="material-symbols-outlined save-draft-icon" title="Delete">delete</span>
                                          </button>



                                        </div>

                                      </div> : <></>}
                                      {console.log((sessionStorage.getItem('RoleIDSS') == 2 || sessionStorage.getItem('RoleIDSS') == 6 || sessionStorage.getItem('RoleIDSS') == 9), '///')}
                                      {(sessionStorage.getItem('RoleIDSS') == 2 || sessionStorage.getItem('RoleIDSS') == 6 || sessionStorage.getItem('RoleIDSS') == 9) ? <></> : item.StatusID == 4 ? editIndex == i && <div className="d-flex">
                                        {/* <div> */}
                                        {/* <span className="text-muted px-2 border-end text-success">
                                                                Approved
                                                            </span> */}
                                        {/* </div> */}
                                        <div
                                          className="d-flex align-items-center  icon-header mb-1"
                                          style={{
                                            fontFamily: "sans-serif",
                                            scale: "0.6",
                                            marginTop: "-2px",
                                            // marginRight: '1rem'
                                            //  zIndex: rejectReasonModal ? 0 : 1
                                          }}
                                        ><button
                                          type="button"
                                          className="btn btn-warning mx-2 d-flex align-items-center"
                                          onClick={() =>
                                            this.setState({ editIndex: null, editOpen: false, }, () => {
                                              setTimeout(() => {
                                                // this.setState({tempListOfVehicles: JSON.parse(JSON.stringify(listOfVehicles))})
                                              }, 100);
                                            })
                                          }
                                        >
                                            <span className="material-symbols-outlined me-1">
                                              close
                                            </span>
                                            Cancel
                                          </button>
                                        </div>
                                      </div> : <></>}
                                      {item.StatusID != 4 && <div className="d-flex">
                                        {/* <div> */}
                                        {/* <span className="text-muted px-2 border-end text-success">
                                                                Approved
                                                            </span> */}
                                        {/* </div> */}
                                        <div
                                          className="d-flex align-items-center  icon-header mb-1"
                                          style={{
                                            fontFamily: "sans-serif",
                                            scale: "0.6",
                                            marginTop: "-2px",
                                            //  zIndex: rejectReasonModal ? 0 : 1
                                          }}
                                        >
                                          {item.ExitPassStatus == "Approved" ? (
                                            <span
                                              className="text-aqua p-1"
                                              style={{
                                                scale: '0.8',
                                                marginRight: "5rem",
                                                marginBottom: "-1rem",
                                              }}
                                            >
                                              <strong>Approved</strong>
                                            </span>
                                          ) : item.ExitPassStatus ==
                                            "Rejected" && RoleId != 16 ? (
                                            <>
                                              <span className="text-danger  p-1"
                                                style={{
                                                  scale: '0.8',
                                                  marginRight: !isView ? "0" : "5rem",
                                                  marginBottom: !isView ? "0" : "-1rem",
                                                }}>
                                                <strong>Rejected</strong>
                                              </span>
                                              <i
                                                class="fa fa-info-circlegrid-icon"
                                                onClick={() =>
                                                  this.setState(
                                                    {
                                                      rejectReason: item.Remark,
                                                    },
                                                    () => {
                                                      this.setState({
                                                        rejectReasonModal: true,
                                                      });
                                                    }
                                                  )
                                                }
                                              ></i>
                                              {!isView && (
                                                <button
                                                  type="button"
                                                  className="btn btn-danger "
                                                  style={{ marginRight: '3rem' }}
                                                  onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Re-Submit?', buttonName: ' Re-Submit', action: 1 }, popArg: [item.ExhExitPassHdrID] })}
                                                // onClick={() =>
                                                //   this.onResubmit(
                                                //     item.ExhExitPassHdrID
                                                //   )
                                                // }

                                                >
                                                  Re-Submit Material Exit pass
                                                </button>
                                              )}
                                            </>
                                          ) : (
                                            <span
                                              className="text-aqua p-1"
                                              style={{
                                                scale: '0.8',
                                                marginRight: "1.5rem",
                                                marginBottom: "-1rem",
                                              }}
                                            >
                                              <strong>Pending for Approval</strong>
                                            </span>
                                            // <h5 className="p-1 text-aqua">  </h5>
                                          )}
                                        </div>
                                      </div>}

                                      {item.StatusID != 4 && (
                                        <div className="d-flex">
                                          {/* <div> */}
                                          {/* <span className="text-muted px-2 border-end text-success">
                                                                Approved
                                                            </span> */}
                                          {/* </div> */}
                                          <div className="d-flex align-items-center mx-2 icon-header">
                                            <i
                                              title="Download Material Exit pass"
                                              className="ri-download-line fs-6 text-primary p-1 rounded-1 px-2 fw-normal"
                                              onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download?', buttonName: 'Download', action: 2 }, popArg: [item.ExhExitPassHdrID] })}
                                            // onClick={() =>

                                            //   this.onPassDownload(
                                            //     item.ExhExitPassHdrID
                                            //   )
                                            // }
                                            />
                                            <i
                                              title="Print Material Exit pass"
                                              className="ri-printer-line fs-6 text-success p-1 rounded-1 px-2 fw-normal"
                                              onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to View?', buttonName: 'View', action: 3 }, popArg: [item.ExhExitPassHdrID] })}
                                            // onClick={() =>

                                            //   this.onPassPrint(
                                            //     item.ExhExitPassHdrID
                                            //   )
                                            // }
                                            />
                                            <i
                                              title="Show QR code"
                                              className="fa fa-qrcode fs-6 text-info p-1 rounded-1 px-2 fw-normal qrIcon"
                                              onClick={() => {
                                                if (item.QRcodeImg) {
                                                  const byteArray =
                                                    item.QRcodeImg.data ||
                                                    item.QRcodeImg;
                                                  const base64 = btoa(
                                                    String.fromCharCode(
                                                      ...byteArray
                                                    )
                                                  );
                                                  this.setState({
                                                    QrCodeImg: `data:image/png;base64,${base64}`,
                                                    isOpen: true,
                                                  });
                                                }
                                              }}
                                            />
                                          </div>

                                        </div>
                                      )}
                                    </h2>
                                    <div
                                      id={`collapseOne_${i}`}
                                      className={
                                        isView
                                          ? "accordion-collapse collapse show"
                                          : editOpen ? editIndex == i ? "accordion-collapse" : "accordion-collapse collapse" : "accordion-collapse collapse"
                                      }
                                      aria-labelledby="headingOne"
                                    >
                                      <div className="accordion-body p-0">
                                        {<h6 className="entry-pass-title mt-3">Vehicle Details</h6>}
                                        <label className="entry-pass-label">
                                          No. of Vehicles
                                        </label>
                                        <input
                                          type="number"
                                          disabled={editOpen ? editIndex == i ? false : true : true}
                                          className="form-control form-control-sm text-center mb-2"
                                          maxLength={10}
                                          style={{
                                            border:
                                              editNoOfVehiclesErr != '' && "1px solid red",
                                          }}
                                          value={editOpen ? editIndex == i ? editNoOfVehicles : item.NoOfVehicle : item.NoOfVehicle}
                                          onChange={(e) => e.target.value != '' && e.target.value != null ? /^[0-9]+$/.test(e.target.value) && this.setState({ editNoOfVehicles: parseInt(e.target.value), editNoOfVehiclesErr: '', }, () => this.onChangeEditNoOFVehicles(e.target.value))
                                            : this.setState({ editNoOfVehicles: '', editNoOfVehiclesErr: '', editListOfVehicles: [] })}
                                        />
                                        {editNoOfVehiclesErr != '' && (
                                          <span className="entry-pass-error">{editNoOfVehiclesErr}</span>
                                        )}
                                        {(editOpen ? editIndex == i ? (editNoOfVehicles != '' && editNoOfVehicles != null && editNoOfVehicles > 0) : (item.NoOfVehicle != '' && item.NoOfVehicle != null && item.NoOfVehicle > 0) : (item.NoOfVehicle != '' && item.NoOfVehicle != null && item.NoOfVehicle > 0)) &&
                                          <div className="table-responsive">
                                            <table className="table table-bordered table-sm mb-0">
                                              <thead className="table-light">
                                                <tr>
                                                  <th style={{ width: 60, textAlign: "center" }}>
                                                    Sr. No.
                                                  </th>
                                                  <th style={{ width: 200, textAlign: "center" }}>
                                                    Vehicle type<span className="text-red">{editOpen && editIndex == i && <span className="text-red">*</span>}</span>
                                                  </th>
                                                  <th style={{ width: 200, textAlign: "center" }}>
                                                    Vehicle No<span className="text-red">{editOpen && editIndex == i && <span className="text-red">*</span>}</span>
                                                  </th>
                                                  <th >
                                                    Driver Name<span className="text-red">{editOpen && editIndex == i && <span className="text-red">*</span>}</span>
                                                  </th>
                                                  <th style={{ width: 200, textAlign: "center" }}>
                                                    Driver Mobile No.<span className="text-red">{editOpen && editIndex == i && <span className="text-red">*</span>}</span>
                                                  </th>
                                                  <th style={{ width: 150, textAlign: "center" }}>
                                                    Document<span className="text-red">{editOpen && editIndex == i && <span className="text-red">*</span>}</span>
                                                  </th>
                                                  {editOpen && editIndex == i && <th style={{ width: 60, textAlign: "center" }}>

                                                  </th>}
                                                </tr>
                                              </thead>
                                              {editIndex == i ? <tbody>
                                                {editListOfVehicles.length > 0 ? (
                                                  editListOfVehicles.map(
                                                    (item2, i) => (
                                                      <tr>
                                                        <td className="text-center">{i + 1}</td>
                                                        <td>
                                                          <select className="form-control text-center"
                                                            value={editListOfVehicles[i].VehicleTypeID}
                                                            // disabled
                                                            onChange={(e) => {
                                                              editListOfVehicles[i].VehicleTypeID = e.target.value;
                                                              this.setState({ editListOfVehicles: editListOfVehicles })
                                                            }}
                                                          >
                                                            <option value={''}>Select</option>
                                                            {
                                                              vehicleTypeList.length > 0 && vehicleTypeList.map((data) => (
                                                                <option key={data.VehicleTypeID} value={data.VehicleTypeID} >{data.VehicleTypeName}</option>
                                                              ))
                                                            }
                                                          </select>
                                                        </td>
                                                        <td className="text-center">
                                                          <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100 px-1 w-100"
                                                            placeholder="Enter No."
                                                            maxLength={20}
                                                            onInput={(e) => this.maxLengthCheck(e, 20)}

                                                            // disabled
                                                            value={editListOfVehicles[i].VehicleNo}
                                                            onChange={(e) => {
                                                              editListOfVehicles[i].VehicleNo = e.target.value;
                                                              this.setState({ editListOfVehicles: editListOfVehicles })
                                                            }
                                                            }
                                                          />
                                                        </td>
                                                        <td >
                                                          <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100 px-1 w-100"
                                                            placeholder="Enter Name"
                                                            maxLength={200}
                                                            value={editListOfVehicles[i].DriverName}
                                                            onChange={(e) => {
                                                              editListOfVehicles[i].DriverName = e.target.value;
                                                              this.setState({ editListOfVehicles: editListOfVehicles })
                                                            }
                                                            }
                                                          // disabled
                                                          />
                                                        </td>
                                                        <td className="text-center">
                                                          <input
                                                            type="number"
                                                            className="form-control form-control-sm w-100 px-1 w-100"
                                                            placeholder="Enter No."
                                                            maxLength={10}
                                                            onInput={(e) => this.maxLengthCheck(e, 10)}

                                                            // disabled
                                                            value={editListOfVehicles[i].DriverMobNo}
                                                            onChange={(e) => {
                                                              editListOfVehicles[i].DriverMobNo = e.target.value;
                                                              this.setState({ editListOfVehicles: editListOfVehicles })
                                                            }
                                                            }
                                                          />
                                                        </td>
                                                        <td style={{ width: '', position: 'relative' }}>
                                                          {/* {(data.isMachine || data.IsAccessory) && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>} */}
                                                          {editListOfVehicles[i].driverDocName != '' && editListOfVehicles[i].driverDocName != null ? <div style={{
                                                            border: '1px solid #ccc',
                                                            padding: '10px',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            // marginTop: '10px'
                                                          }}>
                                                            {editListOfVehicles[i].driverDocdeleted == false ? <a
                                                              href={editListOfVehicles[i].driverDocPath}
                                                              target="_blank"
                                                              rel="noopener noreferrer"
                                                            >
                                                              <span style={{ marginRight: '10px' }}
                                                              >{editListOfVehicles[i].driverDocName}</span>
                                                            </a> : <span onClick={() => this.renderNewImage(editListOfVehicles[i].driverDocFile, editListOfVehicles[i].driverDocType)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                            >{editListOfVehicles[i].driverDocName}</span>}                                                            <i className={`fa fa-times text-danger img-can`}
                                                              onClick={(e) => this.setState({ isDelOpen: true, delID: editListOfVehicles[i].ExitVehicleDtlID })}
                                                            ></i>
                                                          </div>
                                                            : <div className="upload-options mt-1">

                                                              <input
                                                                type="file"
                                                                id={`file${i}`}
                                                                ref={this.fileInputRef}
                                                                name={`file${i}`}
                                                                style={{ display: 'none' }}
                                                                className="image-upload"
                                                                accept=".jpg, .jpeg, .png, .pdf"
                                                                onChange={e => this.onEditFilePick(e, e.target.files, i)}
                                                              />

                                                              <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() => document.getElementById(`file${i}`).click()}
                                                              >
                                                                {editListOfVehicles[i].VehicleTypeID != '' && editListOfVehicles[i].VehicleTypeID != null ? editListOfVehicles[i].VehicleTypeID == 1 ? 'Upload Driving Licence' : 'Upload any Government proof' : 'Upload licence'}
                                                              </button>

                                                              {this.state.fileName && (
                                                                <span className="selected-file-name">{this.state.fileName}</span>
                                                              )}

                                                            </div>}
                                                        </td>
                                                        <td style={{ width: '', position: 'relative' }}>
                                                          <button
                                                            type="button"
                                                            className="btn btn-sm"
                                                            onClick={(e) => {
                                                              tempListOfVehicles.splice(i, 1);
                                                              editListOfVehicles.splice(i, 1);
                                                              this.setState({ tempListOfVehicles: tempListOfVehicles, editListOfVehicles: editListOfVehicles, editNoOfVehicles: editNoOfVehicles - 1 })
                                                            }
                                                            }
                                                          >
                                                            <i className="bi bi-trash text-danger" />
                                                          </button>
                                                        </td>
                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr className="text-center">
                                                    <td>Record not found</td>
                                                  </tr>
                                                )}
                                              </tbody> : <tbody>
                                                {console.log('itemitemitem', item)}
                                                {item.vehicleList.length > 0 ? (
                                                  item.vehicleList.map(
                                                    (item2, i) => (
                                                      <tr>
                                                        <td className="text-center">{i + 1}</td>
                                                        <td>
                                                          <select className="form-control text-center"
                                                            value={item2.VehicleTypeID}
                                                            disabled
                                                          // onChange={(e) => {
                                                          //   listOfVehicles[i].type = e.target.value;
                                                          //   this.setState({ listOfVehicles: listOfVehicles })
                                                          // }}
                                                          >
                                                            <option value={''}>Select</option>
                                                            {
                                                              vehicleTypeList.length > 0 && vehicleTypeList.map((data) => (
                                                                <option key={data.VehicleTypeID} value={data.VehicleTypeID} >{data.VehicleTypeName}</option>
                                                              ))
                                                            }
                                                          </select>
                                                        </td>
                                                        <td className="text-center">
                                                          <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100 px-1 w-100 text-center"
                                                            placeholder="Vehicle No."
                                                            maxLength={20}
                                                            disabled
                                                            value={item2.VehicleNo}
                                                          // onChange={(e) => {
                                                          //   listOfVehicles[i].driverNo = e.target.value;
                                                          //   this.setState({ listOfVehicles: listOfVehicles })
                                                          // }
                                                          // }
                                                          />
                                                        </td>
                                                        <td >
                                                          <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100 px-1 w-100"
                                                            placeholder="Enter Name"
                                                            maxLength={200}
                                                            value={item2.DriverName}
                                                            // onChange={(e) => {
                                                            //   listOfVehicles[i].driverName = e.target.value;
                                                            //   this.setState({ listOfVehicles: listOfVehicles })
                                                            // }
                                                            // }
                                                            disabled
                                                          />
                                                        </td>
                                                        <td className="text-center">
                                                          <input
                                                            type="number"
                                                            className="form-control form-control-sm w-100 px-1 w-100 text-center"
                                                            placeholder="Driver mob No."
                                                            maxLength={20}
                                                            disabled
                                                            value={item2.DriverMobNo}
                                                          // onChange={(e) => {
                                                          //   listOfVehicles[i].driverNo = e.target.value;
                                                          //   this.setState({ listOfVehicles: listOfVehicles })
                                                          // }
                                                          // }
                                                          />
                                                        </td>
                                                        <td style={{ width: '', position: 'relative' }}>
                                                          {/* {(data.isMachine || data.IsAccessory) && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>} */}
                                                          {item2.driverDocName != '' && item2.driverDocName != null && item2.driverDocName != undefined ? <div style={{
                                                            border: '1px solid #ccc',
                                                            padding: '10px',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            // marginTop: '10px'
                                                          }}>
                                                            <a
                                                              href={item2.driverDocPath}
                                                              target="_blank"
                                                              rel="noopener noreferrer"
                                                            >
                                                              <span style={{ marginRight: '10px' }}
                                                              >{item2.driverDocName}</span>
                                                            </a>
                                                            {/* <i className={`fa fa-times text-danger img-can`}
                                                          onClick={(e) => this.onVehicleDocDelete(item.EntryVehicleDtlID, i)}
                                                          ></i> */}
                                                          </div>
                                                            : <div style={{
                                                              border: '1px solid #ccc',
                                                              padding: '10px',
                                                              display: 'inline-flex',
                                                              alignItems: 'center',
                                                              // marginTop: '10px'
                                                            }}>
                                                              {/* <a
                                                                // href={item2.driverDocPath}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                              > */}

                                                              <span style={{ marginRight: '10px', color: 'red' }}
                                                              >  (Please upload Document)</span>
                                                              {/* </a> */}

                                                            </div>
                                                          }
                                                        </td>
                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr className="text-center">
                                                    <td>Record not found</td>
                                                  </tr>
                                                )}
                                              </tbody>}
                                            </table>
                                          </div>}
                                        <div class="card-body p-1">
                                          <div class="d-flex justify-content-between align-items-center">
                                            {/* <!-- Left text --> */}
                                            {item.Remark != "" && item.ExitPassStatus != "Approved" && RoleId != 16 &&
                                              item.Remark != null ? (
                                              <div
                                                className="text-danger"
                                                style={{ fontSize: "medium" }}
                                              >
                                                <strong>Reject Reason:</strong>
                                                &nbsp; {item.Remark}
                                              </div>
                                            ) : (
                                              <div></div>
                                            )}

                                            {/* <!-- Right radio buttons --> */}
                                            <div class="d-flex align-items-center">
                                              <div class="form-check form-check-inline mb-0">

                                                <label
                                                  style={{
                                                    pointerEvents: "none",
                                                    background: "transparent"
                                                  }}
                                                >
                                                  <input
                                                    style={{
                                                      color:
                                                        item.IsFullOut != 1 &&
                                                        "#000",
                                                      opacity:
                                                        item.IsFullOut != 1 &&
                                                        "10",
                                                      background:
                                                        item.IsFullOut != 1 &&
                                                        "#2e69f8",
                                                      pointerEvents: "none",
                                                    }}
                                                    class="form-check-input mt-1"
                                                    type="radio"
                                                    checked={item.IsFullOut != 1}
                                                    // name={`outType_${i}`}
                                                    readOnly
                                                    // id={`partialOut_${i}`}
                                                    value="Partial"
                                                  /> Partial Out
                                                </label>

                                              </div>

                                              <div class="form-check form-check-inline mb-0">

                                                <label
                                                  style={{
                                                    pointerEvents: "none",
                                                    background: "transparent"
                                                  }}
                                                >
                                                  <input
                                                    style={{
                                                      color:
                                                        item.IsFullOut == 1 &&
                                                        "#000",
                                                      opacity:
                                                        item.IsFullOut == 1 &&
                                                        "10",
                                                      background:
                                                        item.IsFullOut == 1 &&
                                                        "#2e69f8",
                                                      pointerEvents: "none",
                                                      // background: "transparent"
                                                    }}
                                                    class="form-check-input mt-1"
                                                    type="radio"
                                                    checked={item.IsFullOut == 1}
                                                    // name={`outType_${i}`}
                                                    readOnly
                                                    // id={`fullOut_${i}`}
                                                    value="Full"
                                                  /> Full Out
                                                </label>

                                              </div>
                                            </div>
                                          </div>

                                          <div class="table-responsive">
                                            <table
                                              class="table table-bordered table-sm mb-2"
                                              id="stockTable"
                                            >
                                              <thead className="table-light">
                                                <tr>
                                                  <th
                                                    style={{
                                                      width: 60,
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Sr. No.
                                                  </th>
                                                  <th>Item Name{editOpen && editIndex == i && <span className="text-red">*</span>}</th>
                                                  {editOpen && editIndex == i && <th
                                                    style={{
                                                      width: 100,
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Total Qty
                                                  </th>}
                                                  {editOpen && editIndex == i && <th
                                                    style={{
                                                      width: 100,
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Balance Qty
                                                  </th>}
                                                  <th
                                                    style={{
                                                      width: 100,
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Qty{editOpen && editIndex == i && <span className="text-red">*</span>}
                                                  </th>
                                                  {editOpen && editIndex == i && <th style={{ width: 60, textAlign: "center" }}></th>}
                                                </tr>
                                              </thead>
                                              {editIndex == i ? <tbody>
                                                {editListItemsTocarry.length >
                                                  0 ? (
                                                  editListItemsTocarry.map(
                                                    (data, index) => (
                                                      <tr>
                                                        <td className="text-center">
                                                          {index + 1}
                                                        </td>
                                                        <td>  <input
                                                          type="text"
                                                          style={{
                                                            border:
                                                              item.Nameerr && "1px solid red",
                                                          }}
                                                          className="form-control form-control-sm w-100 px-1"
                                                          placeholder="Enter item"
                                                          maxLength={200}
                                                          value={data.ItemName}
                                                          disabled={data.isFromDb ? true : editOpen ? editIndex == i ? false : true : true}
                                                          onChange={(e) =>
                                                            this.handleInputEdit(
                                                              e,
                                                              "varchar",
                                                              "ItemName",
                                                              index
                                                            )
                                                          }
                                                        /></td>
                                                        {editOpen && editIndex == i && <td className="text-center">
                                                          {data.isFromDb ? data.totalqty : ''}
                                                        </td>}
                                                        {editOpen && editIndex == i && <td className="text-center">
                                                          {data.isFromDb ? data.BalanceQuantity : ''}
                                                        </td>}
                                                        <td className="text-center">
                                                          <input
                                                            type="text"
                                                            style={{
                                                              border:
                                                                item.Quantityerr && "1px solid red",
                                                            }}
                                                            className="form-control form-control-sm w-100 px-1 text-center"
                                                            placeholder="Enter Qty"
                                                            maxLength={200}
                                                            value={data.Quantity}
                                                            disabled={editOpen ? editIndex == i ? false : true : true}
                                                            onChange={(e) =>
                                                              this.handleInputEdit(
                                                                e,
                                                                "varchar",
                                                                "Quantity",
                                                                index
                                                              )
                                                            }
                                                          /></td>
                                                        {editOpen && editIndex == i && <td className="text-center">
                                                          <button
                                                            type="button"
                                                            className="btn btn-sm"
                                                            onClick={(e) => this.removeItemEdit(index)}
                                                          >
                                                            <i className="bi bi-trash text-danger" />
                                                          </button>
                                                        </td>}
                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr className="text-center">
                                                    <td>Record not found</td>
                                                  </tr>
                                                )}
                                              </tbody> :
                                                <tbody>
                                                  {item.itemToCarryList.length >
                                                    0 ? (
                                                    item.itemToCarryList.map(
                                                      (data, index) => (
                                                        <tr>
                                                          <td className="text-center">
                                                            {index + 1}
                                                          </td>
                                                          <td>{data.ItemName}</td>
                                                          <td className="text-center">
                                                            {data.Quantity}
                                                          </td>
                                                        </tr>
                                                      )
                                                    )
                                                  ) : (
                                                    <tr className="text-center">
                                                      <td>Record not found</td>
                                                    </tr>
                                                  )}
                                                </tbody>}
                                            </table>
                                          </div>
                                          {editOpen && editIndex == i && <button
                                            type="button"
                                            className="btn btn-blue-border m-2"
                                            onClick={() => {
                                              const updatedList = [...this.state.editListItemsTocarry];
                                              updatedList.push({
                                                ItemName: "",
                                                Quantity: "",
                                                Nameerr: false,
                                                Quantityerr: false,
                                                // isFromDB: true
                                              });
                                              this.setState({ editListItemsTocarry: updatedList });
                                            }}
                                          >
                                            <i className="bi bi-plus-circle me-1" /> Add More
                                            Items
                                          </button>}

                                        </div>
                                        {editOpen && editIndex == i && <div className="row mb-2">
                                          <div className="col d-flex justify-content-end">
                                            <button
                                              style={{ backgroundColor: '#51cbc0' }}
                                              type="button"
                                              className="btn text-white  mr-2"
                                              onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to  Save As Draft?', buttonName: ' Save As Draft', action: 4 }, popArg: [4] })}
                                            // onClick={() => this.updateExhibitorExitPass(4)}

                                            >
                                              Save As Draft
                                            </button>
                                            <button
                                              style={{ backgroundColor: '#51cbc0' }}
                                              type="button"
                                              className="btn text-white ms-2"
                                              onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 5 }, popArg: [1] })}
                                            // onClick={() => this.updateExhibitorExitPass(1)}

                                            >
                                              Submit
                                            </button>
                                          </div>
                                        </div>}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                              // :                                        <div className="text-left">Record not found</div>
                            }
                            {/* </div> */}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="entry-pass-row border rounded-2 bg-light p-2 mb-1">
                      {!isView ? (
                        <div >
                          <h6 className="entry-pass-title">New Material Exit pass</h6>
                          <div className="entry-pass-card mt-2">
                            <div className="entry-pass-field">
                              <label className="entry-pass-label">
                                <i className="fa fa-calendar entry-pass-icon grid-icon"></i>
                                Exit Date<span className="text-red">*</span>
                              </label>
                              <DatePicker
                                style={{ zIndex: "99999" }}
                                selected={ExitDate != '' && ExitDate != null ? new Date(ExitDate) : ''}
                                dateFormat={"dd/MM/yyyy"}
                                className={`entry-pass-input form-control ${ExitDateErr ? "entry-pass-input-error form-control" : ""
                                  }`}
                                onChange={(date) =>
                                  this.setState({ ExitDate: date, ExitDateErr: "" })
                                }
                                minDate={this.state.setupDate != '' && this.state.setupDate != null ? new Date(this.state.setupDate) : ''}
                                maxDate={this.state.dismantleDate != '' && this.state.dismantleDate != null ? new Date(this.state.dismantleDate) : ''}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText="DD / MM / YYYY"
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {ExitDateErr}
                                </span>
                              }
                            </div>
                          </div>
                          <div className="row">

                            {!isDirectContractor && RoleId != 7 && RoleId != 17 && isVendor != 1 && (
                              <div className="form-group py-3 pt-1 pb-2 m-0">
                                <label className="form-label d-block mb-2">
                                  Select Category
                                </label>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input mt-1"
                                    type="radio"
                                    name="userType"
                                    id="exhibitor"
                                    checked={categoryType == "Exhibitor"}
                                    disabled={isView || RoleId == 16}
                                    onChange={() =>
                                      this.setState(
                                        {
                                          categoryType: "Exhibitor",
                                          ContractorId: null,
                                          isFullOut: false,
                                        },
                                        () => {
                                          this.getExhibitorExitPassDetails();
                                          this.handleClearErr();
                                        }
                                      )
                                    }
                                  />
                                  <label
                                    className="form-check-label "
                                    htmlFor="exhibitor"
                                  >
                                    Exhibitor
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input mt-1"
                                    type="radio"
                                    name="userType"
                                    disabled={isView || RoleId == 16}
                                    id="contractor"
                                    checked={categoryType == "contractor"}
                                    onChange={() =>
                                      this.setState(
                                        {
                                          categoryType: "contractor",
                                          ContractorId: null,
                                          categoryList: [],
                                          isFullOut: false,
                                        },
                                        () => {
                                          this.handleClearErr();
                                        }
                                      )
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="contractor"
                                  >
                                    Contractor
                                  </label>
                                </div>
                              </div>
                            )}
                          </div>
                          {categoryType === "contractor" &&
                            RoleId != 7 && RoleId != 17 &&
                            isVendor != 1 && (
                              <div class="row pb-3">
                                <div className="col-xl-3">
                                  <select
                                    className={
                                      isDirectContractor
                                        ? "form-control  mt-3"
                                        : "form-control"
                                    }
                                    value={ContractorId}
                                    disabled={
                                      isView || isDirectContractor || RoleId == 16
                                    }
                                    onChange={(e) =>
                                      this.setState(
                                        { ContractorId: parseInt(e.target.value) },
                                        () => {
                                          if (e.target.value != "Select") {
                                            this.getExhibitorExitPassDetails();
                                          } else {
                                            this.setState({ categoryList: [] });
                                          }
                                          this.handleClearErr();
                                        }
                                      )
                                    }
                                  >
                                    <option value={"Select"}>Select</option>
                                    {contractorList.length > 0 &&
                                      contractorList.map((data) => (
                                        <option
                                          key={data.ContractorID}
                                          value={data.ContractorID}
                                        >
                                          {data.ContractorID == 0 ? data.CompanyName : `${data.CompanyName}-${data.Service}`}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                            )}
                          {ContractorId === 0 && (
                            <div class="row pb-3">
                              <div className="col-xl-3">
                                <label htmlFor="validationCustom03">
                                  Person Name<span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={personName}
                                  disabled={isView || RoleId == 16}
                                  maxLength={100}
                                  onChange={(e) =>
                                    this.setState({
                                      personName: e.target.value.replace(
                                        /[^a-zA-Z ]/g,
                                        ""
                                      ),
                                      personNameErr: "",
                                    })
                                  }
                                />
                                {
                                  <span className="text-danger text-start text-left d-block mt-1">
                                    {personNameErr}
                                  </span>
                                }
                              </div>
                              <div className="col-xl-3">
                                <label htmlFor="validationCustom03">
                                  Company Name<span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={companyName}
                                  disabled={isView || RoleId == 16}
                                  maxLength={200}
                                  onChange={(e) =>
                                    this.setState({
                                      companyName: e.target.value,
                                      companyNameErr: "",
                                    })
                                  }
                                />
                                {
                                  <span className="text-danger text-start text-left d-block mt-1">
                                    {companyNameErr}
                                  </span>
                                }
                              </div>
                              <div className="col-xl-3">
                                <label htmlFor="validationCustom03">
                                  Contact No<span className="text-red">*</span>
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={contactNo}
                                  disabled={isView || RoleId == 16}
                                  // maxLength={countryId == 91 ? 10 : 20}
                                  maxLength={10}
                                  // onInput={(e) => this.maxLengthCheck(e, countryId == 91 ? 10 : 20)} 
                                  onInput={(e) => this.maxLengthCheck(e, isNational ? 10 : 20)}
                                  // onKeyDown={(e) => this.preventMinus(e)}
                                  onWheel={(e) => e.target.blur()}
                                  onPaste={(e) => this.handlePaste(e)}
                                  onChange={(e) =>
                                    this.setState({
                                      contactNo: e.target.value.replace(/\D/g, ""),
                                      contactNoErr: "",
                                    })
                                  }
                                />
                                {
                                  <span className="text-danger text-start text-left d-block mt-1">
                                    {contactNoErr}
                                  </span>
                                }
                              </div>
                              <div className="col-xl-3">
                                <label htmlFor="validationCustom03">
                                  Email ID<span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={email}
                                  maxLength={100}
                                  disabled={isView || RoleId == 16}
                                  onChange={(e) =>
                                    this.setState({
                                      email: e.target.value,
                                      emailErr: "",
                                    })
                                  }
                                />
                                {
                                  <span className="text-danger text-start text-left d-block mt-1">
                                    {emailErr}
                                  </span>
                                }
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        isVendor != 1 && (
                          <div class="container-fluid p-0">
                            <div
                              class="shadow-none border-1 rounded-3 mb-3"
                              style={{ border: "1px solid #ced4da" }}
                            >
                              <div
                                class="card-header fw-semibold py-2"
                              >
                                Representative for Stall Possession
                              </div>
                              <div class="card-body row pt-3">
                                <div class="col-xl-3">
                                  <label>
                                    Person Name<span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    maxlength="100"
                                    class="form-control"
                                    value={RSPpersonName}
                                    onChange={(e) =>
                                      this.setState({
                                        RSPpersonName: e.target.value,
                                        RSPpersonNameErr: "",
                                      })
                                    }
                                    maxLength={100}
                                    onInput={(e) => this.maxLengthCheck(e, 100)}
                                    onWheel={(e) => e.target.blur()}
                                    onPaste={(e) => this.handlePaste(e)}
                                    disabled={true}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {RSPpersonNameErr}
                                    </span>
                                  }
                                </div>

                                <div class="col-xl-3">
                                  <label>
                                    Company Name<span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    maxlength="100"
                                    class="form-control"
                                    value={RSPcompanyName}
                                    onChange={(e) =>
                                      this.setState({
                                        RSPcompanyName: e.target.value,
                                        RSPcompanyNameErr: "",
                                      })
                                    }
                                    maxLength={100}
                                    onInput={(e) => this.maxLengthCheck(e, 100)}
                                    onWheel={(e) => e.target.blur()}
                                    onPaste={(e) => this.handlePaste(e)}
                                    disabled={true}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {RSPcompanyNameErr}
                                    </span>
                                  }
                                </div>

                                <div class="col-xl-3">
                                  <label>
                                    Contact No<span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    maxlength="100"
                                    class="form-control"
                                    value={RSPcontactNo}
                                    onChange={(e) =>
                                      this.setState({
                                        RSPcontactNo: e.target.value,
                                        RSPcontactNoErr: "",
                                      })
                                    }
                                    maxLength={10}
                                    onInput={(e) => this.maxLengthCheck(e, 10)}
                                    onWheel={(e) => e.target.blur()}
                                    onPaste={(e) => this.handlePaste(e)}
                                    disabled={true}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {RSPcontactNoErr}
                                    </span>
                                  }
                                </div>

                                <div class="col-xl-3">
                                  <label>
                                    Email ID<span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    maxlength="100"
                                    class="form-control"
                                    value={RSPemailID}
                                    onChange={(e) =>
                                      this.setState({
                                        RSPemailID: e.target.value,
                                        RSPemailIDErr: "",
                                      })
                                    }
                                    maxLength={100}
                                    onInput={(e) => this.maxLengthCheck(e, 100)}
                                    onWheel={(e) => e.target.blur()}
                                    onPaste={(e) => this.handlePaste(e)}
                                    disabled={true}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {RSPemailIDErr}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                            <div
                              class="shadow-none border-1 rounded-3 mb-3"
                              style={{ border: "1px solid #ced4da" }}
                            >
                              <div
                                class="card-header fw-semibold py-2"
                              >Representative for Exit
                              </div>
                              <div class="card-body row pt-3">
                                <div class="col-xl-3">
                                  <label>
                                    Person Name<span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    maxlength="100"
                                    class="form-control"
                                    value={REpersonName}
                                    onChange={(e) =>
                                      this.setState({
                                        REpersonName: e.target.value,
                                        REpersonNameErr: "",
                                      })
                                    }
                                    maxLength={100}
                                    onInput={(e) => this.maxLengthCheck(e, 100)}
                                    onWheel={(e) => e.target.blur()}
                                    onPaste={(e) => this.handlePaste(e)}
                                    disabled={ExitPassStatus != 'Pending' || RoleId == 16}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {REpersonNameErr}
                                    </span>
                                  }
                                </div>

                                <div class="col-xl-3">
                                  <label>
                                    Company Name<span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    maxlength="100"
                                    class="form-control"
                                    value={REcompanyName}
                                    onChange={(e) =>
                                      this.setState({
                                        REcompanyName: e.target.value,
                                        REcompanyNameErr: "",
                                      })
                                    }
                                    maxLength={100}
                                    onInput={(e) => this.maxLengthCheck(e, 100)}
                                    onWheel={(e) => e.target.blur()}
                                    onPaste={(e) => this.handlePaste(e)}
                                    disabled={ExitPassStatus != 'Pending' || RoleId == 16}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {REcompanyNameErr}
                                    </span>
                                  }
                                </div>

                                <div class="col-xl-3">
                                  <label>
                                    Contact No<span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    maxlength="100"
                                    class="form-control"
                                    value={REcontactNo}
                                    onChange={(e) =>
                                      this.setState({
                                        REcontactNo: e.target.value,
                                        REcontactNoErr: "",
                                      })
                                    }
                                    maxLength={10}
                                    onInput={(e) => this.maxLengthCheck(e, 10)}
                                    onWheel={(e) => e.target.blur()}
                                    onPaste={(e) => this.handlePaste(e)}
                                    disabled={ExitPassStatus != 'Pending' || RoleId == 16}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {REcontactNoErr}
                                    </span>
                                  }
                                </div>

                                <div class="col-xl-3">
                                  <label>
                                    Email ID<span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    maxlength="100"
                                    class="form-control"
                                    value={REemailID}
                                    onChange={(e) =>
                                      this.setState({
                                        REemailID: e.target.value,
                                        REemailIDErr: "",
                                      })
                                    }
                                    maxLength={100}
                                    onInput={(e) => this.maxLengthCheck(e, 100)}
                                    onWheel={(e) => e.target.blur()}
                                    onPaste={(e) => this.handlePaste(e)}
                                    disabled={ExitPassStatus != 'Pending' || RoleId == 16}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {REemailIDErr}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </div>

                    {extraServices.length > 0 &&
                      !isDirectContractor &&
                      !isApproved &&
                      RoleId != 16 && !isVendor &&
                      RoleId != 7 && RoleId != 17 && (
                        <div className="card shadow-none rounded-3 mb-0 border p-0 mb-3 mt-2">
                          <div className="card-header text-dark py-2 bg-card-header d-flex justify-content-between align-items-center">
                            <div>
                              <i class="bi bi-briefcase me-2"></i> Extra Services
                            </div>
                            {!isView ? (
                              !isView && toShowPay ? (
                                <form
                                  // onSubmit={(e) => this.navPayment(e)}
                                  ref={this.submitfrm}
                                  id="nonseamless"
                                  method="post"
                                  name="redirect"
                                  action={this.state.paymentLink}
                                >
                                  {/* <input type="hidden" id="encRequest" name="encRequest"
                                                    value={encPayload}
                                                />
                                                <input type="hidden" name="access_code" id="access_code"
                                                    value={paymentAccessCode}
                                                /> */}
                                  <button class="btn btn-aqua">
                                    {/* <span style={{ color: 'black', padding: "4px 25px", fontWeight: 500, }}> */}
                                    Pay Now
                                    {/* </span> */}
                                    {/* {!isPaid && isCarParking == 1 ? 'Make Payment' : 'Update'} */}
                                  </button>
                                </form>
                              ) : (
                                <p class="text-aqua mt-3 font-medium">
                                  (Payment is done. Admin will review it, issue
                                  the receipt, and Outstanding amount will be
                                  cleared)
                                </p>
                              )
                            ) : toShowPay ? (
                              <></>
                            ) : (
                              <p class="text-aqua mt-3 font-medium">
                                (Payment is done. But Material Exit pass can be generated
                                only after Receipt is created by admin)
                              </p>
                            )}
                          </div>
                          <div class="card-body px-2 pb-2">
                            <div class="table-responsive mt-2">
                              <table class="table table-bordered table-striped align-middle mb-0">
                                <thead class="table-light">
                                  <tr>
                                    <th
                                      class="text-center"
                                      scope="col"
                                      style={{ width: "50px" }}
                                    >
                                      Sr.No
                                    </th>
                                    <th scope="col">Service</th>
                                    <th scope="col" class="text-end">
                                      Total Payable Amount
                                    </th>
                                    <th scope="col" class="text-end">
                                      Paid Amount
                                    </th>
                                    <th scope="col" class="text-end">
                                      Outstanding
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {extraServices.length > 0 &&
                                    extraServices.map((item, i) => (
                                      <tr>
                                        <td class="text-center">{i + 1}</td>
                                        <td>{item.Service}</td>
                                        <td class="text-end">
                                          {sessionStorage.getItem(
                                            "ApplicationDataSS"
                                          ) != null
                                            ? JSON.parse(
                                              sessionStorage.getItem(
                                                "ApplicationDataSS"
                                              )
                                            ).CurrencyID == 1
                                              ? "₹"
                                              : "$"
                                            : "₹"}{" "}
                                          {item.TotalPayable.toLocaleString(
                                            "en-IN"
                                          )}
                                        </td>
                                        <td class="text-end">
                                          {sessionStorage.getItem(
                                            "ApplicationDataSS"
                                          ) != null
                                            ? JSON.parse(
                                              sessionStorage.getItem(
                                                "ApplicationDataSS"
                                              )
                                            ).CurrencyID == 1
                                              ? "₹"
                                              : "$"
                                            : "₹"}{" "}
                                          {item.PaidAmount.toLocaleString(
                                            "en-IN"
                                          )}
                                        </td>
                                        <td class="text-end text-danger">
                                          {sessionStorage.getItem(
                                            "ApplicationDataSS"
                                          ) != null
                                            ? JSON.parse(
                                              sessionStorage.getItem(
                                                "ApplicationDataSS"
                                              )
                                            ).CurrencyID == 1
                                              ? "₹"
                                              : "$"
                                            : "₹"}{" "}
                                          {item.Outstanding.toLocaleString(
                                            "en-IN"
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                                <tfoot class="table-light">
                                  <tr>
                                    <th colspan="2" class="fw-semibold">
                                      Total
                                    </th>
                                    <th class="text-end fw-semibold">
                                      {sessionStorage.getItem(
                                        "ApplicationDataSS"
                                      ) != null
                                        ? JSON.parse(
                                          sessionStorage.getItem(
                                            "ApplicationDataSS"
                                          )
                                        ).CurrencyID == 1
                                          ? "₹"
                                          : "$"
                                        : "₹"}{" "}
                                      {totalPayable.toLocaleString("en-IN")}
                                    </th>
                                    <th class="text-end fw-semibold">
                                      {sessionStorage.getItem(
                                        "ApplicationDataSS"
                                      ) != null
                                        ? JSON.parse(
                                          sessionStorage.getItem(
                                            "ApplicationDataSS"
                                          )
                                        ).CurrencyID == 1
                                          ? "₹"
                                          : "$"
                                        : "₹"}{" "}
                                      {totalPaidAmount.toLocaleString("en-IN")}
                                    </th>
                                    <th class="text-end text-danger fw-semibold">
                                      {sessionStorage.getItem(
                                        "ApplicationDataSS"
                                      ) != null
                                        ? JSON.parse(
                                          sessionStorage.getItem(
                                            "ApplicationDataSS"
                                          )
                                        ).CurrencyID == 1
                                          ? "₹"
                                          : "$"
                                        : "₹"}{" "}
                                      {totalOutstanding.toLocaleString("en-IN")}
                                    </th>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>

                            {console.log(isView, sessionStorage.getItem('RoleIDSS') == 6, 'PendingPending')}
                            {isView && toShowPay && (
                              <>
                                <div class="d-flex align-items-center ms-4 pt-2">
                                  <label class="d-flex text-warning">
                                    <input
                                      type="checkbox"
                                      id="hallManagerCheck"
                                      class="form-check-input me-2 "
                                      disabled={ExitPassStatus != 'Pending'}
                                      value={isWaiverOn}
                                      checked={isWaiverOn}
                                      onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Waive Off?', buttonName: 'Waive Off', action: 6 }, popArg: [] })}
                                    // onClick={() => this.onWaiveClick()}

                                    />{" "}
                                    <span className="text-dark"> Waive Off </span> <br />
                                    {/* <div> */}
                                    {/* </div> */}
                                  </label>
                                </div>
                                <div class={this.state.approvalStatus == "Waiting for Approval" ? 'd-flex text-aqua fw-semibold' : 'd-flex text-aqua fw-semibold'} style={{ fontSize: 'larger' }}>
                                  {this.state.approvalStatus}
                                </div>
                              </>

                            )}
                            {isWaiverOn && (
                              <div
                                id="waiveOffFields"
                                class="row g-2"
                                style={{ display: "flex" }}
                              >
                                {!otpValid && this.state.approvalStatus != 'Approved' && (
                                  <label class="col-form-label text-primary mt-2 pt-2">
                                    <span
                                      class="text-primary  mt-2 pt-2"
                                      onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Waive Off?', buttonName: 'Waive Off', action: 6 }, popArg: [] })}
                                      // onClick={() => this.onWaiveClick()}

                                      style={{
                                        cursor: "pointer",
                                        zIndex: "999999",
                                      }}
                                    >
                                      Resend waive Off Approval mail
                                    </span>
                                  </label>
                                )}
                                {/* <div class="col-md-3">
                                <label class="col-form-label">
                                  Senior Authority's OTP/ Password
                                  <span class="text-danger">*</span>
                                </label>
                                <div style={{ display: "flex" }}>
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder=""
                                    value={inputOTP}
                                    onChange={(e) =>
                                      this.setState({
                                        inputOTP: e.target.value,
                                        inputOTPErr: "",
                                      })
                                    }
                                    maxLength={100}
                                    onInput={(e) => this.maxLengthCheck(e, 100)}
                                    onWheel={(e) => e.target.blur()}
                                    onPaste={(e) => this.handlePaste(e)}
                                    onBlur={() => this.checkOTP()}
                                    disabled={otpValid}
                                  />
                                  {otpValid && (
                                    <i
                                      style={{ margin: "10px" }}
                                      class="fa fa-check text-success"
                                      aria-hidden="true"
                                    ></i>
                                  )}
                                </div>
                                {
                                  <span className="text-danger text-start text-left d-block mt-1">
                                    {this.state.inputOTPErr}
                                  </span>
                                }
                              </div> */}
                                <div class="col-md-3">
                                  <label class="col-form-label">
                                    Approved By Name
                                    <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder=""
                                    disabled
                                    value={approvedByName}
                                    onChange={(e) =>
                                      this.setState({
                                        approvedByName: e.target.value,
                                        approvedByNameErr: "",
                                      })
                                    }
                                    maxLength={100}
                                    onInput={(e) => this.maxLengthCheck(e, 100)}
                                    onWheel={(e) => e.target.blur()}
                                    onPaste={(e) => this.handlePaste(e)}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {this.state.approvedByNameErr}
                                    </span>
                                  }
                                </div>
                                <div class="col-md-6">
                                  <label class="col-form-label">Remark</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder=""
                                    value={remark}
                                    onChange={(e) =>
                                      this.setState({ remark: e.target.value })
                                    }
                                    maxLength={1000}
                                    onInput={(e) => this.maxLengthCheck(e, 1000)}
                                    onWheel={(e) => e.target.blur()}
                                    onPaste={(e) => this.handlePaste(e)}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    {(sessionStorage.getItem('RoleIDSS') == 2 || sessionStorage.getItem('RoleIDSS') == 6 || sessionStorage.getItem('RoleIDSS') == 9) && <div className="row">
                      <div className="col-md-4">
                        <label className="col-form-label">
                          ITME Staff Name<span className="text-red">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={ITMEStaffName ? ITMEStaffName : ''}
                          disabled={ExitPassStatus != 'Pending'}

                          // disabled={IsNDCIssued}
                          onChange={(e) =>
                            this.setState({
                              ITMEStaffName: e.target.value.replace(/[^a-zA-Z ]/g, ""),
                              ITMEStaffNameErr: "",
                            })
                          }
                        />
                        {
                          <span className="text-danger text-start text-left d-block mt-1">
                            {ITMEStaffNameErr}
                          </span>
                        }
                      </div>
                      <div className="col-md-4">
                        <label className="col-form-label">
                          Date<span className="text-red">*</span>
                        </label>
                        <DatePicker
                          selected={IssuedDate ? moment(IssuedDate).toDate() : ''}
                          disabled={ExitPassStatus != 'Pending'}
                          // disabled={IsNDCIssued}
                          minDate={new Date()}
                          onChange={(e) =>
                            this.setState({ IssuedDate: e, IssuedDateErr: "" }, () => console.log(moment(e).toDate(), new Date()))
                          }
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={1} // choose time in 15-min steps
                          dateFormat="dd-MM-yyyy HH:mm"
                          placeholderText="Select date and time"
                          className="form-control"
                        />
                        {
                          <span className="text-danger text-start text-left d-block mt-1">
                            {IssuedDateErr}
                          </span>
                        }
                      </div>
                    </div>}
                    {!isView && RoleId != 16 && (
                      <div className="row mx-0 mt-2">
                        {/* <div className="card shadow-none rounded-3 mb-0 border p-0 mb-3">
                          <div className="card-header  text-dark py-2 bg-card-header">
                            <i className="bi bi-exclamation-circle-fill grid-icon me-2" />
                            Important Notes
                          </div>
                          <div className="card-body py-1 p-0">
                            <ol className="mb-0" style={{ listStyleType: 'none' }}>
                              <li>
                                <strong>Step 1: Important Note</strong>
                                <p >If the Exhibitor has any pending dues, the Exhibitor / Stand Contractor (E/SC) will not be able to fill the Material Exit pass. All dues must be cleared first. The Accounts team will generate a receipt, and the option to fill out the Material Exit pass will be enabled only after the receipt is issued.</p>
                              </li>
                              <li>
                                <strong>Step 2: Empty Vehicle Move-In for Loading & Hall Manager Certification:</strong>
                                <p >Once the Material Exit pass is approved:</p>
                                <p >The Exhibitor / Exhibitor Representative / Stand Contractor (E/ER/SC) shall coordinate with the respective Hall Manager or authorised freight forwarder to arrange the required truck or tempo for material movement.</p>
                                <p >Exhibitor / Exhibitor Representative / Stand Contractor (E/ER/SC) will show the Material Exit pass to the Hall Manager or Security Personnel at the freight entry gate of the IEML Venue, and security will scan the Material Exit pass.</p>
                                <p >After clearance, proceed to the allocated hall from the nearest freight entry gate and show the Material Exit pass to security at the respective gate. </p>
                              </li>
                              <li>
                                <p style={{ textIndent: '20px' }}><strong >Tasks to be completed during move-in and loading:</strong></p>
                                <p style={{ textIndent: '20px' }}>Once truck loading is complete, the Exhibitor / Exhibitor Representative / Stand Contractor (E/ER/SC) should approach the respective Hall Manager for damage verification. </p>
                                <p style={{ textIndent: '20px' }}>The Hall Manager will review the submitted Material Exit pass in the system and assess whether any damage has occurred, marking the damage status as<strong> “Yes” or “No.”</strong></p>
                                <ul className="mt-0" style={{ listStyleType: 'disc' }}>
                                  <li>If no damage is reported, the system will automatically approve the Material Exit pass, and the loaded vehicles of the E/ER/SC shall proceed towards the exit of the exhibition hall.</li>
                                  <li>If damage is reported, the Material Exit pass issued will be sent to the Accounts Team for approval. The E/ER/SC will not be permitted to proceed with the Material Exit pass until it has been approved by the Accounts department.</li>
                                </ul>
                              </li>
                              <p className="my-3" style={{ textAlign: 'center' }}><strong>No material movement will be permitted without a Hall manager approved Material Exit pass.</strong></p>

                              <li className="mb-3">
                                <strong>Step 3: DD Return (Exhibitor Representative/Stand Contractor):</strong>
                                <p>
                                  After receiving Material Exit pass approval from the Hall Manager, the Exhibitor Representative / Stand Contractor (ER/SC) will visit the site office to collect the Demand Draft (DD) for the ITME Accounts team.
                                </p>
                              </li>

                              <li className="mb-3">
                                <strong>Step 4: Material Exit pass Scanning:</strong>
                                <p>
                                  Download the approved Material Exit pass → Scan at Venue Freight Entry Gate → Scan at Hall Freight Entry Gate → Scan at the Hall Manager desk → Scan at Hall Freight Exit → Final Scan at Venue Gate.
                                </p>
                              </li>
                            </ol>
                          </div>
                        </div> */}
                      </div>
                    )}

                    {!isView && RoleId != 16 && (
                      <div className="row mx-0">
                        <div className="card shadow-none rounded-3 mb-0 border p-0 mb-3">
                          <div className="card shadow-none rounded-3 mb-0 border p-0">
                            <div className="card-header  text-dark py-2 bg-card-header" style={{ justifyContent: 'left' }}>
                              <i className="bi bi-car-front-fill me-2 grid-icon" />
                              Vehicle details
                            </div>
                            <div className="card-body px-2 pt-1 pb-2">
                              <div className="entry-pass-field">
                                <label className="entry-pass-label">
                                  No. of Vehicles
                                </label>
                                <input
                                  type="number"
                                  className="form-control form-control-sm text-center"
                                  maxLength={10}
                                  style={{
                                    border:
                                      noOfVehiclesErr != '' && "1px solid red",
                                  }}
                                  value={noOfVehicles}
                                  onChange={(e) => e.target.value != '' && e.target.value != null ? /^[0-9]+$/.test(e.target.value) && this.setState({ noOfVehicles: parseInt(e.target.value), noOfVehiclesErr: '', tempMainListOfVehicles: listOfVehicles.length != 0 ? JSON.parse(JSON.stringify(listOfVehicles)) : this.state.tempMainListOfVehicles }, () => {
                                    setTimeout(() => {
                                      this.onChangeNoOFVehicles(e.target.value)
                                    }, 100);
                                  })
                                    : this.setState({ noOfVehicles: '', noOfVehiclesErr: '', tempMainListOfVehicles: listOfVehicles.length != 0 ? JSON.parse(JSON.stringify(listOfVehicles)) : this.state.tempMainListOfVehicles }, () => {
                                      // this.setState({ listOfVehicles: [],})
                                      this.onChangeNoOFVehicles(e.target.value)
                                    })}
                                />
                                {noOfVehiclesErr != '' && (
                                  <span className="entry-pass-error">{noOfVehiclesErr}</span>
                                )}
                              </div>
                              {listOfVehicles.length > 0 && <p className="fw-semibold mb-0">
                                Please Enter the Details of the Driving Person:
                              </p>}
                              {listOfVehicles.length > 0 && <div className="table-responsive ">
                                <table
                                  className="table table-bordered table-sm mb-2"
                                  id="itemsTable1"
                                >
                                  <thead className="table-light">
                                    <tr>
                                      <th style={{ width: 60, textAlign: "center" }}>
                                        Sr. No.
                                      </th>
                                      <th style={{ width: 200, textAlign: "center" }}>
                                        Vehicle type<span className="text-red">*</span>
                                      </th>
                                      <th style={{ width: 200, textAlign: "center" }}>
                                        Vehicle No.<span className="text-red">*</span>
                                      </th>
                                      <th >
                                        Driver Name<span className="text-red">*</span>
                                      </th>
                                      <th style={{ width: 200, textAlign: "center" }}>
                                        Driver Mobile No.<span className="text-red">*</span>
                                      </th>
                                      <th style={{ width: 150, textAlign: "center" }}>
                                        Document<span className="text-red">*</span>
                                      </th>
                                      <th style={{ width: 60, textAlign: "center" }}>
                                        {/* <span className="text-red">*</span> */}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {listOfVehicles.length > 0 &&
                                      listOfVehicles.map((item, i) => (
                                        <tr>
                                          <td className="text-center">{i + 1}</td>
                                          <td>
                                            <select className="form-control text-center"
                                              value={item.type}
                                              onChange={(e) => {
                                                listOfVehicles[i].type = e.target.value;
                                                this.setState({ listOfVehicles: listOfVehicles })
                                              }}
                                            >
                                              <option value={''}>Select</option>
                                              {
                                                vehicleTypeList.length > 0 && vehicleTypeList.map((data) => (
                                                  <option key={data.VehicleTypeID} value={data.VehicleTypeID} >{data.VehicleTypeName}</option>
                                                ))
                                              }
                                            </select>
                                            {/* <input
                                            type="text"
                                            style={{
                                              border:
                                                item.Nameerr && "1px solid red",
                                            }}
                                            className="form-control form-control-sm w-100 px-1 w-100"
                                            placeholder="Enter item"
                                            maxLength={200}
                                            value={item.Name}
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "varchar",
                                                "Name",
                                                i
                                              )
                                            }
                                          /> */}
                                          </td>
                                          <td className="text-center">
                                            <input
                                              type="text"
                                              className="form-control form-control-sm w-100 px-1 w-100 text-center"
                                              placeholder="Vehicle No."
                                              onInput={(e) => this.maxLengthCheck(e, 20)}
                                              maxLength={20}
                                              value={item.VehicleNo}
                                              onChange={(e) => {
                                                listOfVehicles[i].VehicleNo = e.target.value;
                                                this.setState({ listOfVehicles: listOfVehicles })
                                              }
                                              }
                                            />
                                          </td>
                                          <td >
                                            <input
                                              type="text"
                                              className="form-control form-control-sm w-100 px-1 w-100"
                                              placeholder="Driver Name"
                                              maxLength={200}
                                              value={item.driverName}
                                              onChange={(e) => {
                                                listOfVehicles[i].driverName = e.target.value;
                                                this.setState({ listOfVehicles: listOfVehicles })
                                              }
                                              }
                                            />
                                          </td>
                                          <td className="text-center">
                                            <input
                                              type="number"
                                              className="form-control form-control-sm w-100 px-1 w-100 text-center"
                                              placeholder="Driver mob No."
                                              onInput={(e) => this.maxLengthCheck(e, 10)}
                                              maxLength={10}
                                              value={item.driverNo}
                                              onChange={(e) => {
                                                listOfVehicles[i].driverNo = e.target.value;
                                                this.setState({ listOfVehicles: listOfVehicles })
                                              }
                                              }
                                            />
                                          </td>
                                          <td style={{ width: '', position: 'relative' }}>
                                            {/* {(data.isMachine || data.IsAccessory) && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>} */}
                                            {item.driverDocName != '' ? <div style={{
                                              border: '1px solid #ccc',
                                              padding: '10px',
                                              display: 'inline-flex',
                                              alignItems: 'center',
                                              // marginTop: '10px'
                                            }}>
                                              {/* {console.log(this.state.isSSifile)} */} <a
                                                href={item.driverDocPath}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                <span style={{ marginRight: '10px' }}
                                                >{item.driverDocName}</span>
                                              </a>
                                              <i className={`fa fa-times text-danger img-can`}
                                                onClick={(e) => this.onVehicleDocDelete(item.ExitVehicleDtlID, i)}
                                              ></i>
                                            </div>
                                              : <div className="upload-options mt-1">

                                                <input
                                                  type="file"
                                                  id={`file${i}`}
                                                  ref={this.fileInputRef}
                                                  name={`file${i}`}
                                                  style={{ display: 'none' }}
                                                  className="image-upload"
                                                  accept=".jpg, .jpeg, .png, .pdf"
                                                  onChange={e => this.onFilePick(e, e.target.files, i)}
                                                />

                                                <button
                                                  type="button"
                                                  className="btn btn-primary"
                                                  onClick={() => document.getElementById(`file${i}`).click()}
                                                >
                                                  {item.type != '' && item.type != null ? item.type == 1 ? 'Upload Driving Licence' : 'Upload any Government proof' : 'Upload licence'}
                                                </button>

                                                {
                                                  item.driverDocFile !== "" &&
                                                  <i
                                                    className="fa fa-times text-danger img-can"
                                                    onClick={() => this.onCrossClick(i)}
                                                  ></i>
                                                }

                                              </div>}
                                          </td>
                                          <td style={{ width: '', position: 'relative' }}>
                                            <button
                                              type="button"
                                              className="btn btn-sm"
                                              onClick={(e) => {
                                                tempMainListOfVehicles.splice(i, 1);
                                                listOfVehicles.splice(i, 1);
                                                this.setState({ tempMainListOfVehicles: tempMainListOfVehicles, listOfVehicles: listOfVehicles, noOfVehicles: noOfVehicles - 1 })
                                              }
                                              }
                                            >
                                              <i className="bi bi-trash text-danger" />
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </div>}
                            </div>
                          </div>
                        </div>
                        <div className="card shadow-none rounded-3 mb-0 border p-0 mb-3">
                          <div className="card-header  text-dark py-2 bg-card-header" style={{ justifyContent: 'left' }}>
                            <i className="bi bi-box-seam me-2 grid-icon" />
                            Items to Exit
                          </div>
                          <div className="card-body px-2 pb-2 pt-0">
                            <div class="d-flex justify-content-between align-items-center pt-2 fw-semibold mb-0 gap-1">
                              <p class="mb-0">
                                Please list the items (bags, cartons, packages,
                                etc.) you wish to carry back after the exhibition:
                              </p>
                              <div class="d-flex align-items-center">
                                <div class="form-check me-3 mb-0">
                                  <label class="" for="partialOut">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      disabled={isAll0}
                                      checked={!isFullOut}
                                      name="outType"
                                      id="partialOut"
                                      value="Partial"
                                      onChange={() => this.onPOut()}
                                    />{" "}
                                    Partial Out
                                  </label>
                                </div>
                                <div class="form-check mb-0">
                                  <label class="" for="fullOut">
                                    {" "}
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      disabled={isAll0}
                                      checked={isFullOut}
                                      name="outType"
                                      id="fullOut"
                                      value="Full"
                                      onChange={() => this.onFullOut()}
                                    />{" "}
                                    Full Out
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="table-responsive ">
                              <table
                                className="table table-bordered table-sm mb-2"
                                id="itemsTable1"
                              >
                                <thead className="table-light">
                                  <tr>
                                    <th
                                      style={{ width: 60, textAlign: "center" }}
                                    >
                                      Sr. No.
                                    </th>
                                    <th className="px-2">
                                      Item Name
                                      <span className="text-red">*</span>
                                    </th>
                                    <th
                                      style={{ width: 60, textAlign: "center" }}
                                    >
                                      Total In Qty
                                    </th>
                                    <th
                                      style={{ width: 60, textAlign: "center" }}
                                    >
                                      Previous Out Qty{" "}
                                    </th>
                                    <th
                                      style={{ width: 60, textAlign: "center" }}
                                    >
                                      Balance Qty
                                    </th>
                                    <th
                                      style={{ width: 60, textAlign: "center" }}
                                    >
                                      Current Out Qty
                                    </th>
                                    <th
                                      style={{ width: 60, textAlign: "center" }}
                                    >
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {itemToCarryList.length > 0 &&
                                    itemToCarryList.map(
                                      (item, i) =>
                                        item.BalanceQuantity != 0 && (
                                          <tr>
                                            <td className="text-center">
                                              {i + 1}
                                            </td>
                                            <td>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm w-100 px-1"
                                                placeholder="Enter item"
                                                maxLength={200}
                                                style={{
                                                  border:
                                                    item.Nameerr &&
                                                    "1px solid red",
                                                }}
                                                value={item.ItemName}
                                                disabled={item.isFromDb}
                                                onChange={(e) =>
                                                  this.handleInput(
                                                    e,
                                                    "varchar",
                                                    "ItemName",
                                                    i
                                                  )
                                                }
                                              />
                                            </td>
                                            <td className="text-center">
                                              {item.TotalQuantity}
                                            </td>
                                            <td className="text-center">
                                              {item.PreviousOutQuantity}
                                            </td>
                                            <td className="text-center">
                                              {item.BalanceQuantity}
                                            </td>
                                            <td className="text-center">
                                              <input
                                                type="text"
                                                className="form-control form-control-sm w-100 text-center"
                                                maxLength={10}
                                                disabled={isFullOut}
                                                value={item.Quantity}
                                                onChange={(e) =>
                                                  this.handleInput(
                                                    e,
                                                    "int",
                                                    "Quantity",
                                                    i
                                                  )
                                                }
                                              />
                                            </td>
                                            <td className="text-center">
                                              {item.isDelete != false && (
                                                <button
                                                  type="button"
                                                  className="btn btn-sm"
                                                  onClick={(e) =>
                                                    this.removeItem(i)
                                                  }
                                                >
                                                  <i className="bi bi-trash text-danger" />
                                                </button>
                                              )}
                                            </td>
                                          </tr>
                                        )
                                    )}
                                </tbody>
                              </table>
                            </div>
                            <button
                              disabled={isFullOut}
                              type="button"
                              className="btn btn-blue-border mt-2"
                              onClick={() => {
                                const updatedList = [
                                  ...this.state.itemToCarryList,
                                ];
                                updatedList.push({
                                  ItemName: "",
                                  Quantity: "",
                                  isFromDb: false,
                                  Nameerr: false,
                                  Quantityerr: false,
                                });
                                this.setState({ itemToCarryList: updatedList });
                              }}
                            >
                              <i className="bi bi-plus-circle me-1" /> Add More
                              Items
                            </button>

                            <div class="d-flex justify-content-between align-items-center pt-2 fw-semibold mb-0 gap-1">
                              <p class="mb-0">
                                <strong>Note:</strong> The exhibitor agrees to compensate for any damages caused by the stall fabricator he or she has appointed during the dismantling of the stall.
                              </p>
                              <br />
                            </div>
                            <div className="mx-1 my-2">
                              <label className="d-flex" >
                                <input type="checkbox" style={{ height: 25 }}
                                  name={IsAgree}
                                  value={IsAgree}
                                  checked={IsAgree}
                                  onClick={e => this.setState({ IsAgree: !IsAgree })}
                                />
                                {/* {data.label}  {data.ExhRegistrationNotesId == 1041 ? */}
                                <p className='text-dark' >{" "} I agree that my space has been fully cleared as per exhibition exit rules.</p>
                              </label>
                            </div>
                          </div>

                        </div>
                      </div>
                    )}

                    {console.log(
                      isVendor == 1
                        ? false
                        : otpValid
                          ? false
                          : totalOutstanding == 0
                            ? false
                            : true,
                      totalOutstanding,
                      totalOutstanding == 0,
                      otpValid,
                      isVendor == 1
                    )}

                    {RoleId == 16 ? (
                      <div className="row mt-1 ">
                        <div class="col d-flex justify-content-end">
                          {/* <button type="button" class="btn btn-gray px-2 p-1 mx-2" onClick={() =>   this.props.navigate(-1)}>Back</button> */}
                        </div>
                        <div className="col d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn text-white btn-gray"
                            onClick={() => this.props.navigate(-1)}
                          >
                            Back
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="row mt-1 mb-3 mb-lg-none">
                        {isView ? (
                          ExitPassStatus != "Pending" && ExitPassStatus != "" ? (
                            <></>
                          ) : !isApproved ? (
                            <div class="col d-flex justify-content-end">
                              <button
                                type="submit"
                                class="btn  btn-aqua me-2"
                                onClick={() => this.onGenerateExitPass(1)}

                                disabled={
                                  isVendor == 1
                                    ? false
                                    :
                                    totalOutstanding == 0
                                      ? false
                                      : this.state.approvalStatus != 'Approved'
                                }
                              >
                                Accept &amp; Generate Material Exit pass
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-danger "
                                onClick={() =>
                                  this.setState({ refuseModal: true })
                                }
                              >
                                Refuse
                              </button>
                            </div>
                          ) : (
                            <div class="col d-flex justify-content-end">
                              {" "}
                              <button
                                type="button"
                                disabled
                                class="btn btn-outline-success "
                                onClick={() =>
                                  this.setState({ refuseModal: true })
                                }
                              >
                                Approved
                              </button>
                            </div>
                          )
                        ) : (
                          <>
                            <div className="col d-flex justify-content-end">
                              {/* {extraServices.length > 0 &&
                            RoleId != 16 && !isVendor &&
                            RoleId != 7 && RoleId != 17 ? <strong className="mt-2 mx-2 text-danger">{isDirectContractor ? '(The Exhibitor has not cleared the pending dues. Kindly contact the exhibitor to clear the pending dues before generating Material Exit pass)' : '(Please clear all the pending dues before generating ExitPass)'}</strong> : this.state.isLastExitPass ? <strong className="mt-2 mx-2 text-danger">{isDirectContractor ? '(You have already created the last Material Exit pass for this Exhibitor, if you want to create more Material Exit pass, kindly contact ITME accounts person)' : '(You have already created the last Material Exit pass, if you want to create more Material Exit pass, kindly contact ITME accounts person)'}</strong>
                             : <></>} */}
                              <button
                                type="button"
                                style={{ backgroundColor: '#51cbc0' }}
                                className="btn text-white"
                                // disabled={extraServices.length > 0 &&
                                //   RoleId != 16 && !isVendor &&
                                //   RoleId != 7 && RoleId != 17 ? true : this.state.isLastExitPass}
                                disabled={true}
                                onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to    Save as Draft?', buttonName: '   Save as Draft', action: 7 }, popArg: [4] })}
                              // onClick={() => this.submitExhibitorExitPass(4)}

                              >
                                Save as Draft
                              </button>
                              <button
                                type="button"
                                style={{ backgroundColor: '#51cbc0' }}
                                className="btn text-white ms-2"
                                // disabled={extraServices.length > 0 &&
                                //   RoleId != 16 && !isVendor &&
                                //   RoleId != 7 && RoleId != 17 ? true : this.state.isLastExitPass}
                                // disabled={true}
                                onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 8 }, popArg: [1] })}
                              // onClick={() => this.submitExhibitorExitPass(1)}

                              >
                                Submit
                              </button>
                            </div>
                            <p className="text-danger mb-0" style={{ textAlign: 'right' }}>The submission of the exit pass will be enabled soon.</p>
                          </>
                        )}
                      </div>
                    )}

                    {/* Bootstrap Tooltip Init */}
                  </section>
              }
              <Modal
                isOpen={isOpen}
                onRequestClose={() => this.setState({ isOpen: false })}
              >
                <div className="modal-dialog">
                  <div className="modal-content confirm-logout">
                    <div class="modal-header p-2">
                      <h5 class="modal-title modal_title_text text-white">
                        Scan below QR in Kiosk Device for print Material Exit pass
                      </h5>
                      {/* <button
                        type="button "
                        class="close pop-close"
                        data-dismiss="modal"
                        onClick={() => this.setState({ isOpen: false })}
                        style={{ background: "#eeeeee" }}
                      >
                        <span aria-hidden="true" class="pop-cancel"> 
                          &times;
                        </span>
                      </button> */}
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12 text-center">
                          <img
                            src={this.state.QrCodeImg}
                            alt="QR Code"
                            className="rounded-2xl shadow-lg w-64 h-64 object-contain"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer p-1">
                      <div class="form-group text-right mod-fot">
                        <button
                          type="button"
                          class="btn btn-gray"
                          data-dismiss="modal"
                          style={{ marginLeft: "5px" }}
                          onClick={() => this.setState({ isOpen: false })}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
              <Modal
                isOpen={isCopyModal}
                onRequestClose={() => this.setState({ isCopyModal: false })}
              >
                <div className="modal-dialog">
                  <div className="modal-content confirm-logout">
                    <div class="modal-header p-2">
                      <h5 class="modal-title modal_title_text">
                        Share Link to Contractor
                      </h5>
                      <button
                        type="button "
                        class="close pop-close"
                        data-dismiss="modal"
                        onClick={() => this.setState({ isCopyModal: false })}
                        style={{ background: "#eeeeee" }}
                      >
                        <span aria-hidden="true" class="pop-cancel">
                          &times;
                        </span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div className="table-responsive ">
                        <table
                          className="table table-bordered table-sm mb-2"
                          id="itemsTable1"
                        >
                          <thead className="table-light">
                            <tr>
                              <th style={{ width: 60, textAlign: "center" }}>
                                Sr. No.
                              </th>
                              <th>Contractor</th>
                              <th style={{ width: 60, textAlign: "center" }}>
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {contractorList.length > 0 &&
                              contractorList.map(
                                (item, i) =>
                                  item.ContractorID != 0 && (
                                    <tr>
                                      <td className="text-center">{i + 1}</td>
                                      <td>{item.CompanyName}</td>
                                      <td className="text-center">
                                        <button
                                          type="button"
                                          className={
                                            i == copiedIndex && isCopied
                                              ? "btn btn-white text-success border-success"
                                              : "btn btn-white text-secondary border-secondary"
                                          }
                                          // onClick={() => this.submitExhibitorExitPass()}
                                          onClick={() =>
                                            this.copyToClipboard(item.UUID, i)
                                          }
                                        >
                                          {i == copiedIndex && isCopied ? (
                                            <span className="text-success">
                                              <i
                                                class="fa fa-check text-success"
                                                aria-hidden="true"
                                              ></i>{" "}
                                              Copied
                                            </span>
                                          ) : (
                                            "Copy Link"
                                          )}
                                        </button>
                                      </td>
                                    </tr>
                                  )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="modal-footer p-1">
                      <div class="form-group text-right mod-fot">
                        <button
                          type="button"
                          class="btn btn-gray"
                          data-dismiss="modal"
                          style={{ marginLeft: "5px" }}
                          onClick={() =>
                            this.setState({ isCopyModal: false })
                          }
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
              <Modal
                isOpen={refuseModal}
                onRequestClose={() => this.setState({ refuseModal: false })}
              >
                <div className="modal-dialog">
                  <div className="modal-content confirm-logout">
                    <div class="modal-header bg-danger text-white py-2">
                      <h5 class="modal-title" style={{ fontSize: "16px" }}>
                        Refuse Confirmation
                      </h5>
                      <button
                        type="button"
                        class="btn-close btn-close-white text-white"
                        onClick={() => this.setState({ refuseModal: false })}
                      ></button>
                    </div>
                    <div class="modal-body">
                      <div class="mb-0">
                        <label class="col-form-label">Reason</label>
                        <textarea
                          id="refuseReason"
                          class="form-control"
                          rows="4"
                          placeholder="Enter reason here..."
                          onChange={(e) =>
                            this.setState({ refuseReason: e.target.value })
                          }
                          value={this.state.refuseReason}
                        ></textarea>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-gray"
                        onClick={() => this.setState({ refuseModal: false })}
                      >
                        Back
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger"
                        onClick={() => this.onGenerateExitPass(0)}
                      >
                        Refuse
                      </button>
                    </div>
                  </div>
                </div>
              </Modal>
              <Modal
                isOpen={rejectReasonModal}
                onRequestClose={() =>
                  this.setState({
                    rejectReasonModal: false,
                    rejectReason: "",
                  })
                }
              >
                <div className="modal-dialog">
                  <div className="modal-content confirm-logout">
                    <div class="modal-header bg-danger text-white py-2">
                      <h5 class="modal-title" style={{ fontSize: "16px" }}>
                        Reject Reason
                      </h5>
                      <button
                        type="button"
                        class="btn-close btn-close-white text-white"
                        onClick={() =>
                          this.setState({
                            rejectReasonModal: false,
                            rejectReason: "",
                          })
                        }
                      ></button>
                    </div>
                    <div class="modal-body">
                      {/* <div class="mb-0">
                                                <label class="col-form-label">Reason</label>
                                                <textarea id="refuseReason" class="form-control" rows="4" placeholder="Enter reason here..." onChange={(e) => this.setState({ refuseReason: e.target.value })} value={this.state.refuseReason}></textarea>
                                            </div> */}
                      {this.state.rejectReason}
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-gray bg-secondary"
                        onClick={() =>
                          this.setState({
                            rejectReasonModal: false,
                            rejectReason: "",
                          })
                        }
                      >
                        OK
                      </button>
                      {/* <button type="button" class="btn btn-danger" onClick={() => this.onGenerateExitPass(0)}>Refuse</button> */}
                    </div>
                  </div>
                </div>
              </Modal>
              <Modal isOpen={deletePop} onRequestClose={() => this.setState({ deletePop: false })}>
                <div className="modal-dialog">
                  <div className="modal-content confirm-logout">
                    <div class="modal-header bg-danger text-white py-2">
                      <h5 class="modal-title" style={{ fontSize: "16px" }}>Delete Material Exit pass</h5>
                      <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ deletePop: false })} ></button>
                    </div>
                    <div class="modal-body">
                      Do you want to delete this Material Exit pass?
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ deletePop: false })}>No</button>
                      <button type="button" class="btn btn-danger" onClick={() => this.deleteExitPass()}>Yes</button>
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
            {/* </div> */}
          </div>
          {/* </div> */}
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getExitPassPdf_action,
    getExhibitorExitPassDetails_action,
    submitExhibitorExitPass_action,
    sendPaymentForm_action,
    getAccountExitPassDetail_action,
    insertExitPassOTP_action,
    verifyExitPassOTP_action,
    approveRejectExitPass_action, updateExhibitorExitPass_action, deleteEntryPassDriverDoc_action,
    resubmitExitPass_action,
    getVendorBasicDetail_action, checkIfApproved_action,
    checkEntryPassExists_action, deleteExitPass_action
  })(ExhibitorExitPass)
);
